//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from 'moment';
import { ClientConfig, AuthorizedClientBase } from "msg-swagger"
export class SpacesClientConfig extends ClientConfig {
    constructor(schema: string, version: string, getToken: () => string) {
        super(version, getToken);
        this.schema = schema;
    }

    public schema: string;
}

export class SpacesClientBase extends AuthorizedClientBase {
    private readonly schema: string;

    protected constructor(config: SpacesClientConfig) {
        super(config);
        this.schema = config.schema;
    }

    protected transformOptions(options: RequestInit): Promise<RequestInit> {
        if (!this.schema) {
            Promise.reject("schema is not set");
        }

        options.headers = {
            ...options.headers,
            "X-Application-Schema": this.schema
        };

        return super.transformOptions(options);
    }
}

export class AggregateClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get a list of spaces by their ids.
     * @param spaceId The identifier of the spaces that links to the Aggregate Feature
     * @param versionNr (optional) An optional version number of the aggregate
     * @param includeGeometries (optional) What type of geometries should be included in the response (None, Full)
     */
    getAggregate(spaceId: number, versionNr: number | null | undefined, includeGeometries: SpaceGeometryReturnType | undefined): Promise<AggregateDTO> {
        let url_ = this.baseUrl + "/api/Aggregate/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (versionNr !== undefined && versionNr !== null)
            url_ += "versionNr=" + encodeURIComponent("" + versionNr) + "&";
        if (includeGeometries === null)
            throw new Error("The parameter 'includeGeometries' cannot be null.");
        else if (includeGeometries !== undefined)
            url_ += "includeGeometries=" + encodeURIComponent("" + includeGeometries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAggregate(_response);
        });
    }

    protected processGetAggregate(response: Response): Promise<AggregateDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AggregateDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AggregateDTO>(null as any);
    }

    getAggregateVersions(spaceId: number): Promise<AggregateVersionDTO[]> {
        let url_ = this.baseUrl + "/api/Aggregate/{spaceId}/versions";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAggregateVersions(_response);
        });
    }

    protected processGetAggregateVersions(response: Response): Promise<AggregateVersionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AggregateVersionDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AggregateVersionDTO[]>(null as any);
    }
}

export class AggregateMutationClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createAggregate(parentSpaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: AggregateDTO): Promise<AggregateDTO> {
        let url_ = this.baseUrl + "/api/AggregateMutation/create/{parentSpaceId}?";
        if (parentSpaceId === undefined || parentSpaceId === null)
            throw new Error("The parameter 'parentSpaceId' must be defined.");
        url_ = url_.replace("{parentSpaceId}", encodeURIComponent("" + parentSpaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateAggregate(_response);
        });
    }

    protected processCreateAggregate(response: Response): Promise<AggregateDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AggregateDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AggregateDTO>(null as any);
    }

    updateAggregate(spaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: AggregateDTO): Promise<AggregateDTO> {
        let url_ = this.baseUrl + "/api/AggregateMutation/update/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateAggregate(_response);
        });
    }

    protected processUpdateAggregate(response: Response): Promise<AggregateDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AggregateDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AggregateDTO>(null as any);
    }

    decomposeAggregate(spaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/AggregateMutation/decompose/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDecomposeAggregate(_response);
        });
    }

    protected processDecomposeAggregate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class BulkMutationClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Mutate an entire sub tree. [W]
    - It will return the mutated spaceNodeDTOs as a dictionary with as key the nodeReference.
     * @param mutationSubscriberFlag (optional) 
     */
    mutate(mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: BulkMutationDTO): Promise<{ [key: string]: SpaceNodeDTO; }> {
        let url_ = this.baseUrl + "/api/BulkMutation/mutate?";
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMutate(_response);
        });
    }

    protected processMutate(response: Response): Promise<{ [key: string]: SpaceNodeDTO; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (<any>result200)![key] = resultData200[key] ? SpaceNodeDTO.fromJS(resultData200[key]) : new SpaceNodeDTO();
                }
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ValidationProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: SpaceNodeDTO; }>(null as any);
    }
}

export class ExportClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getKmz(exportRequest: ExportRequestDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Export/kmz";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(exportRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetKmz(_response);
        });
    }

    protected processGetKmz(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ExternalLayerClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the list of external WMS/WMTS layers for the user.
     * @param forUpdate (optional) Get layers for update? When set to true, only layers for own tenant are selected.
     */
    getLayers(forUpdate: boolean | undefined): Promise<ExternalLayerDTO[]> {
        let url_ = this.baseUrl + "/api/ExternalLayer/get-layers?";
        if (forUpdate === null)
            throw new Error("The parameter 'forUpdate' cannot be null.");
        else if (forUpdate !== undefined)
            url_ += "forUpdate=" + encodeURIComponent("" + forUpdate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLayers(_response);
        });
    }

    protected processGetLayers(response: Response): Promise<ExternalLayerDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ExternalLayerDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalLayerDTO[]>(null as any);
    }

    /**
     * Store a new external WMS/WMTS layer.
     * @param dto The layer to be created
     */
    create(dto: ExternalLayerDTO): Promise<ExternalLayerDTO> {
        let url_ = this.baseUrl + "/api/ExternalLayer/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<ExternalLayerDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ExternalLayerDTO.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalLayerDTO>(null as any);
    }

    /**
     * Update an existing external WMS/WMTS layer.
     * @param dto The layer to be updated
     */
    update(dto: ExternalLayerDTO): Promise<ExternalLayerDTO> {
        let url_ = this.baseUrl + "/api/ExternalLayer/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<ExternalLayerDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            return response.text().then((_responseText) => {
            let result202: any = null;
            let resultData202 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result202 = ExternalLayerDTO.fromJS(resultData202);
            return result202;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExternalLayerDTO>(null as any);
    }

    /**
     * Delete an existing external WMS/WMTS layer.
     * @param id The id of the layer to be deleted
     */
    delete(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/ExternalLayer/delete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 202) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ProblemDetails.fromJS(resultData401);
            return throwException("A server side error occurred.", status, _responseText, _headers, result401);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class FeatureClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get a feature by the spaceId.
     */
    get(spaceId: number): Promise<FeatureNodeDTO> {
        let url_ = this.baseUrl + "/api/Feature/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FeatureNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FeatureNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureNodeDTO>(null as any);
    }

    /**
     * Get a list of features by their ids.
     * @param featureIds The identifiers of the Features to return
     */
    getFeatureSpacesById(featureIds: number[] | null): Promise<FeatureNodeDTO[]> {
        let url_ = this.baseUrl + "/api/Feature/features-by-id?";
        if (featureIds === undefined)
            throw new Error("The parameter 'featureIds' must be defined.");
        else if(featureIds !== null)
            featureIds && featureIds.forEach(item => { url_ += "featureIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFeatureSpacesById(_response);
        });
    }

    protected processGetFeatureSpacesById(response: Response): Promise<FeatureNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureNodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureNodeDTO[]>(null as any);
    }

    /**
     * Get the symbology of a feature by spaceId.
     */
    getSymbology(spaceId: number): Promise<SymbologyDTO> {
        let url_ = this.baseUrl + "/api/Feature/symbology/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSymbology(_response);
        });
    }

    protected processGetSymbology(response: Response): Promise<SymbologyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SymbologyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SymbologyDTO>(null as any);
    }

    /**
     * Get a download link for a space with a feature that can be downloaded.
    This is an authorized link to the blob storage and will eventualy expire.
    The expiration timestamp is included in the url query parameters.
     * @param versionNr (optional) 
     */
    downloadLinkBySpaceId(spaceId: number, versionNr: number | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Feature/download-link/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (versionNr !== undefined && versionNr !== null)
            url_ += "versionNr=" + encodeURIComponent("" + versionNr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadLinkBySpaceId(_response);
        });
    }

    protected processDownloadLinkBySpaceId(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get a download link for a feature that can be downloaded.
    This is an authorized link to the blob storage and will eventualy expire.
    The expiration timestamp is included in the url query parameters.
     * @param versionNr (optional) 
     */
    downloadLinkByFeatureId(featureId: number, versionNr: number | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Feature/download-link-by-feature-id/{featureId}?";
        if (featureId === undefined || featureId === null)
            throw new Error("The parameter 'featureId' must be defined.");
        url_ = url_.replace("{featureId}", encodeURIComponent("" + featureId));
        if (versionNr !== undefined && versionNr !== null)
            url_ += "versionNr=" + encodeURIComponent("" + versionNr) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadLinkByFeatureId(_response);
        });
    }

    protected processDownloadLinkByFeatureId(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get the results for the given query, including geometry and styling.
     * @param queryId (optional) Identifier of the query.
     * @param excludeGeometries (optional) Whether to exclude (Full) geometries in reponse.
     */
    getSearchFeatures(queryId: number | undefined, excludeGeometries: boolean | undefined): Promise<FeatureNodeDTO[]> {
        let url_ = this.baseUrl + "/api/Feature/get-search-features?";
        if (queryId === null)
            throw new Error("The parameter 'queryId' cannot be null.");
        else if (queryId !== undefined)
            url_ += "queryId=" + encodeURIComponent("" + queryId) + "&";
        if (excludeGeometries === null)
            throw new Error("The parameter 'excludeGeometries' cannot be null.");
        else if (excludeGeometries !== undefined)
            url_ += "excludeGeometries=" + encodeURIComponent("" + excludeGeometries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSearchFeatures(_response);
        });
    }

    protected processGetSearchFeatures(response: Response): Promise<FeatureNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FeatureNodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FeatureNodeDTO[]>(null as any);
    }
}

export class FeatureMutationClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a new feature(space) with a geometry.
     * @param mutationSubscriberFlag (optional) 
     */
    createGeometryFeature(parentSpaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: GeometryFeatureDTO): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/create-geometry-feature/{parentSpaceId}?";
        if (parentSpaceId === undefined || parentSpaceId === null)
            throw new Error("The parameter 'parentSpaceId' must be defined.");
        url_ = url_.replace("{parentSpaceId}", encodeURIComponent("" + parentSpaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeometryFeature(_response);
        });
    }

    protected processCreateGeometryFeature(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Create new feature(space)s with a geometry.
     * @param mutationSubscriberFlag (optional) 
     */
    createGeometryFeatures(parentSpaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dtos: GeometryFeatureDTO[]): Promise<SpaceNodeDTO[]> {
        let url_ = this.baseUrl + "/api/FeatureMutation/create-geometry-features/{parentSpaceId}?";
        if (parentSpaceId === undefined || parentSpaceId === null)
            throw new Error("The parameter 'parentSpaceId' must be defined.");
        url_ = url_.replace("{parentSpaceId}", encodeURIComponent("" + parentSpaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateGeometryFeatures(_response);
        });
    }

    protected processCreateGeometryFeatures(response: Response): Promise<SpaceNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpaceNodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO[]>(null as any);
    }

    /**
     * Update (or add to an existing space) a feature(space) with a geometry.
     * @param mutationSubscriberFlag (optional) 
     */
    updateGeometryFeature(mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: GeometryFeatureDTO): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/update-geometry-feature?";
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateGeometryFeature(_response);
        });
    }

    protected processUpdateGeometryFeature(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Create a new feature(space) without a geometry.
     * @param mutationSubscriberFlag (optional) 
     */
    createItemFeature(parentSpaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: ItemFeatureDTO): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/create-item-feature/{parentSpaceId}?";
        if (parentSpaceId === undefined || parentSpaceId === null)
            throw new Error("The parameter 'parentSpaceId' must be defined.");
        url_ = url_.replace("{parentSpaceId}", encodeURIComponent("" + parentSpaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateItemFeature(_response);
        });
    }

    protected processCreateItemFeature(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Create new feature(space)s without a geometry.
     * @param mutationSubscriberFlag (optional) 
     */
    createItemFeatures(parentSpaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dtos: ItemFeatureDTO[]): Promise<SpaceNodeDTO[]> {
        let url_ = this.baseUrl + "/api/FeatureMutation/create-item-features/{parentSpaceId}?";
        if (parentSpaceId === undefined || parentSpaceId === null)
            throw new Error("The parameter 'parentSpaceId' must be defined.");
        url_ = url_.replace("{parentSpaceId}", encodeURIComponent("" + parentSpaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dtos);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateItemFeatures(_response);
        });
    }

    protected processCreateItemFeatures(response: Response): Promise<SpaceNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpaceNodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO[]>(null as any);
    }

    /**
     * Update (or add to an existing space) a feature(space) without a geometry.
     * @param mutationSubscriberFlag (optional) 
     */
    updateItemFeature(mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: ItemFeatureDTO): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/update-item-feature?";
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateItemFeature(_response);
        });
    }

    protected processUpdateItemFeature(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Link an existing feature to a space. 
    - The permissions of the source space are copied and synced from destination space.
     * @param mutationSubscriberFlag (optional) 
     */
    linkToFeature(sourceSpaceId: number, destinationSpaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/link-to-feature/{sourceSpaceId}/{destinationSpaceId}?";
        if (sourceSpaceId === undefined || sourceSpaceId === null)
            throw new Error("The parameter 'sourceSpaceId' must be defined.");
        url_ = url_.replace("{sourceSpaceId}", encodeURIComponent("" + sourceSpaceId));
        if (destinationSpaceId === undefined || destinationSpaceId === null)
            throw new Error("The parameter 'destinationSpaceId' must be defined.");
        url_ = url_.replace("{destinationSpaceId}", encodeURIComponent("" + destinationSpaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLinkToFeature(_response);
        });
    }

    protected processLinkToFeature(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Unlink a feature from a space.
     * @param mutationSubscriberFlag (optional) 
     */
    unLinkFeature(spaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/unlink-feature/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnLinkFeature(_response);
        });
    }

    protected processUnLinkFeature(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Update the symbology of a feature
     * @param mutationSubscriberFlag (optional) 
     */
    updateSymbology(spaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: SymbologyDTO): Promise<SymbologyDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/symbology/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateSymbology(_response);
        });
    }

    protected processUpdateSymbology(response: Response): Promise<SymbologyDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SymbologyDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SymbologyDTO>(null as any);
    }

    /**
     * Publish a project in OGC services.
     * @param mutationSubscriberFlag (optional) 
     */
    publishForOGC(spaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: PublishOgcDTO): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/publish-for-ogc/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPublishForOGC(_response);
        });
    }

    protected processPublishForOGC(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Unpublish a project in OGC services.
     * @param mutationSubscriberFlag (optional) 
     */
    unpublishForOGC(spaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/FeatureMutation/unpublish-for-ogc/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnpublishForOGC(_response);
        });
    }

    protected processUnpublishForOGC(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }
}

export class RasterTilesClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the (raw data) raster tile for the child features.   
    The raw elevation data in the returned png image is in cm.
     * @param zoom Zoom level
     * @param x x index
     * @param y y index
     * @param requestType Request Type
     * @param id Identifier of the space  or query).
     * @return raster tile
     */
    getRaster(zoom: number, x: number, y: number, requestType: SpacesRequestType, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RasterTiles/{zoom}/{x}/{y}/{requestType}/{id}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRaster(_response);
        });
    }

    protected processGetRaster(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("raster tile", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the (raw data) raster tile for the child features.   
    The raw elevation data in the returned png image is in cm.
     * @param zoom Zoom level
     * @param x x index
     * @param y y index
     * @param requestType Request Type
     * @param id Identifier of the space  or query).
     * @param requestDateTime Date Time  to request the raster tile for
     * @return raster tile
     */
    getRasterByDate(zoom: number, x: number, y: number, requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RasterTiles/{zoom}/{x}/{y}/{requestType}/{id}/{requestDateTime}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRasterByDate(_response);
        });
    }

    protected processGetRasterByDate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("raster tile", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the raster tile for the child features, colorized with the given colorscale.
     * @param zoom Zoom level
     * @param x x index
     * @param y y index
     * @param requestType Request Type
     * @param id Identifier of the space  or query).
     * @param requestDateTime Date Time  to request the raster tile for
     * @param rasterConfig The raster data configuration
     * @return raster tile
     */
    getRasterWithConfiguration(zoom: number, x: number, y: number, requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment, rasterConfig: RasterConfigDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/RasterTiles/with-configuration/{zoom}/{x}/{y}/{requestType}/{id}/{requestDateTime}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(rasterConfig);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRasterWithConfiguration(_response);
        });
    }

    protected processGetRasterWithConfiguration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("raster tile", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the elevation (value) of a specific pixel in the raster.   
    The raw elevation data in the returned png image is in cm.
     * @param zoom Zoom level
     * @param x x index
     * @param y y index
     * @param i The column in the raster for which the value is requested
     * @param j The row in the raster for which the value is requested
     * @param requestType Request Type
     * @param id Identifier of the space  or query).
     * @return elevation or nodata value
     */
    getRasterValue(zoom: number, x: number, y: number, i: number, j: number, requestType: SpacesRequestType, id: number): Promise<number> {
        let url_ = this.baseUrl + "/api/RasterTiles/{zoom}/{x}/{y}/{i}/{j}/{requestType}/{id}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (i === undefined || i === null)
            throw new Error("The parameter 'i' must be defined.");
        url_ = url_.replace("{i}", encodeURIComponent("" + i));
        if (j === undefined || j === null)
            throw new Error("The parameter 'j' must be defined.");
        url_ = url_.replace("{j}", encodeURIComponent("" + j));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRasterValue(_response);
        });
    }

    protected processGetRasterValue(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("elevation or nodata value", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get the elevation (value) of a specific pixel in the raster.   
    The raw elevation data in the returned png image is in cm.
     * @param zoom Zoom level
     * @param x x index
     * @param y y index
     * @param i The column in the raster for which the value is requested
     * @param j The row in the raster for which the value is requested
     * @param requestType Request Type
     * @param id Identifier of the space  or query).
     * @param requestDateTime Date Time  to request the raster tile for
     * @return elevation or nodata value
     */
    getRasterValueByDate(zoom: number, x: number, y: number, i: number, j: number, requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<number> {
        let url_ = this.baseUrl + "/api/RasterTiles/{zoom}/{x}/{y}/{i}/{j}/{requestType}/{id}/{requestDateTime}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (i === undefined || i === null)
            throw new Error("The parameter 'i' must be defined.");
        url_ = url_.replace("{i}", encodeURIComponent("" + i));
        if (j === undefined || j === null)
            throw new Error("The parameter 'j' must be defined.");
        url_ = url_.replace("{j}", encodeURIComponent("" + j));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRasterValueByDate(_response);
        });
    }

    protected processGetRasterValueByDate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("elevation or nodata value", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    /**
     * Get the cross profile.
     * @param requestType Request Type
     * @param id Identifier of the space  or query.
     * @return Cross Profile
     */
    getCrossProfile(requestType: SpacesRequestType, id: number, line: CrossLineDTO): Promise<CrossProfileDTO[]> {
        let url_ = this.baseUrl + "/api/RasterTiles/cross-profile/{requestType}/{id}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(line);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCrossProfile(_response);
        });
    }

    protected processGetCrossProfile(response: Response): Promise<CrossProfileDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CrossProfileDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("Cross Profile", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrossProfileDTO[]>(null as any);
    }

    /**
     * Get the cross profile.
     * @param requestType Request Type
     * @param id Identifier of the space  or query.
     * @param requestDateTime Date Time  to request the raster tile for
     * @return Cross Profile
     */
    getCrossProfile2(requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment, line: CrossLineDTO): Promise<CrossProfileDTO[]> {
        let url_ = this.baseUrl + "/api/RasterTiles/cross-profile/{requestType}/{id}/{requestDateTime}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(line);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCrossProfile2(_response);
        });
    }

    protected processGetCrossProfile2(response: Response): Promise<CrossProfileDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CrossProfileDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("Cross Profile", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CrossProfileDTO[]>(null as any);
    }
}

export class SettingsClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the user settings for the user.
     */
    getUserSettings(): Promise<any> {
        let url_ = this.baseUrl + "/api/Settings/user/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserSettings(_response);
        });
    }

    protected processGetUserSettings(response: Response): Promise<any> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<any>(null as any);
    }

    /**
     * Save or update the user settings for the user. This must be a single JSON object!
     */
    setUserSettings(setting: any): Promise<void> {
        let url_ = this.baseUrl + "/api/Settings/user/set";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setting);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetUserSettings(_response);
        });
    }

    protected processSetUserSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class SpaceClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get a list of spaces by their ids.
     * @param includeGeometries (optional) What type of geometries should be included in the response (None, BoundingBox, Full)
     * @param checkResults (optional) Check that spaces are found for given space ids
     * @param spaceIds The identifiers of the spaces to return
     */
    spacesById(includeGeometries: SpaceGeometryReturnType | undefined, checkResults: boolean | undefined, spaceIds: number[]): Promise<SpaceNodeDTO[]> {
        let url_ = this.baseUrl + "/api/Space/spaces-by-id?";
        if (includeGeometries === null)
            throw new Error("The parameter 'includeGeometries' cannot be null.");
        else if (includeGeometries !== undefined)
            url_ += "includeGeometries=" + encodeURIComponent("" + includeGeometries) + "&";
        if (checkResults === null)
            throw new Error("The parameter 'checkResults' cannot be null.");
        else if (checkResults !== undefined)
            url_ += "checkResults=" + encodeURIComponent("" + checkResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(spaceIds);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSpacesById(_response);
        });
    }

    protected processSpacesById(response: Response): Promise<SpaceNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpaceNodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO[]>(null as any);
    }

    /**
     * Get the child spaces.
     * @param spaceId (optional) Identifier of the parent space. This can be null, then only the root spaces are returned
     * @param includeNonTraversables (optional) Should we also include the spaces that are markes as not traversable in the response?
     * @param includeGeometries (optional) What type of geometries should be included in the response (None, BoundingBox, Full)
     * @param queryRequest Filter and order the results
     */
    getSpaceHierarchy(spaceId: number | null | undefined, includeNonTraversables: boolean | null | undefined, includeGeometries: SpaceGeometryReturnType | undefined, queryRequest: QueryRequestDTO): Promise<NodeResultOfSpaceNodeDTOAndSpaceType> {
        let url_ = this.baseUrl + "/api/Space/hierarchy?";
        if (spaceId !== undefined && spaceId !== null)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        if (includeNonTraversables !== undefined && includeNonTraversables !== null)
            url_ += "includeNonTraversables=" + encodeURIComponent("" + includeNonTraversables) + "&";
        if (includeGeometries === null)
            throw new Error("The parameter 'includeGeometries' cannot be null.");
        else if (includeGeometries !== undefined)
            url_ += "includeGeometries=" + encodeURIComponent("" + includeGeometries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpaceHierarchy(_response);
        });
    }

    protected processGetSpaceHierarchy(response: Response): Promise<NodeResultOfSpaceNodeDTOAndSpaceType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NodeResultOfSpaceNodeDTOAndSpaceType.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NodeResultOfSpaceNodeDTOAndSpaceType>(null as any);
    }

    /**
     * Search for spaces
     * @param spaceId (optional) Identifier of the space to be searched. A value less than or equal to 1 indicates a global search.
     * @param includeNonTraversables (optional) Should we also include the spaces that are markes as not traversable in the response?
     * @param includeGeometries (optional) What type of geometries should be included in the response (None, BoundingBox, Full)
     * @param queryRequest Filter and order the results
     */
    search(spaceId: number | undefined, includeNonTraversables: boolean | null | undefined, includeGeometries: SpaceGeometryReturnType | undefined, queryRequest: QueryRequestDTO): Promise<NodeResultOfSpaceNodeDTOAndSpaceType> {
        let url_ = this.baseUrl + "/api/Space/search?";
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        if (includeNonTraversables !== undefined && includeNonTraversables !== null)
            url_ += "includeNonTraversables=" + encodeURIComponent("" + includeNonTraversables) + "&";
        if (includeGeometries === null)
            throw new Error("The parameter 'includeGeometries' cannot be null.");
        else if (includeGeometries !== undefined)
            url_ += "includeGeometries=" + encodeURIComponent("" + includeGeometries) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(queryRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<NodeResultOfSpaceNodeDTOAndSpaceType> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NodeResultOfSpaceNodeDTOAndSpaceType.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NodeResultOfSpaceNodeDTOAndSpaceType>(null as any);
    }

    /**
     * Get the extent of all features under the space, or the extent of a feature (used in integrations).
     * @param spaceId (optional) Identifier of the space.
     * @param nested (optional) Descend the children of the space. Defaults to false.
     */
    getSpaceExtent(spaceId: number | undefined, nested: boolean | null | undefined): Promise<SpaceExtentDTO> {
        let url_ = this.baseUrl + "/api/Space/space-extent?";
        if (spaceId === null)
            throw new Error("The parameter 'spaceId' cannot be null.");
        else if (spaceId !== undefined)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        if (nested !== undefined && nested !== null)
            url_ += "nested=" + encodeURIComponent("" + nested) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpaceExtent(_response);
        });
    }

    protected processGetSpaceExtent(response: Response): Promise<SpaceExtentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceExtentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceExtentDTO>(null as any);
    }

    /**
     * Get the extent of the results for the given query.
     * @param queryId (optional) Identifier of the query.
     */
    getSearchExtent(queryId: number | undefined): Promise<SearchExtentDTO> {
        let url_ = this.baseUrl + "/api/Space/search-extent?";
        if (queryId === null)
            throw new Error("The parameter 'queryId' cannot be null.");
        else if (queryId !== undefined)
            url_ += "queryId=" + encodeURIComponent("" + queryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSearchExtent(_response);
        });
    }

    protected processGetSearchExtent(response: Response): Promise<SearchExtentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchExtentDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchExtentDTO>(null as any);
    }

    /**
     * Take a list of Space Ids, and store all descendants of each Space as the result of a query  
    By default all feature types are stored, this may be limited by supplying the requested types
     * @return The Query Id
     */
    storeAsQuery(store: SearchStoreResultDTO): Promise<SearchStoredQueryDTO> {
        let url_ = this.baseUrl + "/api/Space/store-as-query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(store);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStoreAsQuery(_response);
        });
    }

    protected processStoreAsQuery(response: Response): Promise<SearchStoredQueryDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchStoredQueryDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchStoredQueryDTO>(null as any);
    }

    /**
     * Get the timeline breaks for based on all features under the space.
     * @param requestType Request Type (Space or Query).
     * @param id Identifier of the project space.
     * @param timelineRequest Timeline parameters
     */
    getSpaceTimelineBreaks(requestType: SpacesRequestType, id: number, timelineRequest: SpaceTimelineRequestDTO): Promise<SpaceTimelineResultDTO> {
        let url_ = this.baseUrl + "/api/Space/timeline-breaks/{requestType}/{id}";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timelineRequest);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpaceTimelineBreaks(_response);
        });
    }

    protected processGetSpaceTimelineBreaks(response: Response): Promise<SpaceTimelineResultDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceTimelineResultDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceTimelineResultDTO>(null as any);
    }
}

export class SpaceLogClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    get(search: string | null | undefined, spaceId: number | null | undefined, featureId: number | null | undefined, skip: number | undefined, take: number | undefined): Promise<LogDTO[]> {
        let url_ = this.baseUrl + "/api/SpaceLog?";
        if (search !== undefined && search !== null)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (spaceId !== undefined && spaceId !== null)
            url_ += "spaceId=" + encodeURIComponent("" + spaceId) + "&";
        if (featureId !== undefined && featureId !== null)
            url_ += "featureId=" + encodeURIComponent("" + featureId) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (take === null)
            throw new Error("The parameter 'take' cannot be null.");
        else if (take !== undefined)
            url_ += "take=" + encodeURIComponent("" + take) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<LogDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LogDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LogDTO[]>(null as any);
    }
}

export class SpaceMutationClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Create a new space. [W]
     * @param mutationSubscriberFlag (optional) 
     */
    create(parentSpaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: SpaceDTO): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/SpaceMutation/create/{parentSpaceId}?";
        if (parentSpaceId === undefined || parentSpaceId === null)
            throw new Error("The parameter 'parentSpaceId' must be defined.");
        url_ = url_.replace("{parentSpaceId}", encodeURIComponent("" + parentSpaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Update an existing Space. [W]
     * @param mutationSubscriberFlag (optional) 
     */
    update(mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: SpaceDTO): Promise<SpaceNodeDTO> {
        let url_ = this.baseUrl + "/api/SpaceMutation/update?";
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<SpaceNodeDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SpaceNodeDTO.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO>(null as any);
    }

    /**
     * Delete a list of existing spaces. [A]
     * @param mutationSubscriberFlag (optional) 
     */
    delete(mutationSubscriberFlag: MutationSubscriberTypes | undefined, itemIds: number[]): Promise<void> {
        let url_ = this.baseUrl + "/api/SpaceMutation/delete?";
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(itemIds);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Move a list of existing Spaces, with all their descendents, to a new parent space (destination). [W]
     * @param mutationSubscriberFlag (optional) 
     */
    move(mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: MutationDTO): Promise<SpaceNodeDTO[]> {
        let url_ = this.baseUrl + "/api/SpaceMutation/move?";
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMove(_response);
        });
    }

    protected processMove(response: Response): Promise<SpaceNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpaceNodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO[]>(null as any);
    }

    /**
     * (Hard)Copy a list of existing Spaces to a parent Space (destination). [W]
     * @param mutationSubscriberFlag (optional) 
     */
    hardCopy(mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: MutationDTO): Promise<SpaceNodeDTO[]> {
        let url_ = this.baseUrl + "/api/SpaceMutation/copy?";
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processHardCopy(_response);
        });
    }

    protected processHardCopy(response: Response): Promise<SpaceNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpaceNodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO[]>(null as any);
    }

    /**
     * (Features as Link)Copy a list of existing Spaces to a parent Space (destination). [W]
     * @param mutationSubscriberFlag (optional) 
     */
    featuresAsLinkCopy(mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: MutationDTO): Promise<SpaceNodeDTO[]> {
        let url_ = this.baseUrl + "/api/SpaceMutation/features-as-link-copy?";
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processFeaturesAsLinkCopy(_response);
        });
    }

    protected processFeaturesAsLinkCopy(response: Response): Promise<SpaceNodeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpaceNodeDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpaceNodeDTO[]>(null as any);
    }
}

export class SpacePermissionClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the permissions for a space. [A]
     */
    get(spaceId: number): Promise<SpacePermissionDTO[]> {
        let url_ = this.baseUrl + "/api/SpacePermission/{spaceId}";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<SpacePermissionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SpacePermissionDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SpacePermissionDTO[]>(null as any);
    }

    /**
     * Update the permissions of a space. [A]
     * @param spaceId The identifier of the space
     * @param mutationSubscriberFlag (optional) 
     * @param dto The list of permissions of the space
     * @return The ids of the spaces affected by this update
     */
    update(spaceId: number, mutationSubscriberFlag: MutationSubscriberTypes | undefined, dto: SpacePermissionDTO[]): Promise<number[]> {
        let url_ = this.baseUrl + "/api/SpacePermission/{spaceId}?";
        if (spaceId === undefined || spaceId === null)
            throw new Error("The parameter 'spaceId' must be defined.");
        url_ = url_.replace("{spaceId}", encodeURIComponent("" + spaceId));
        if (mutationSubscriberFlag === null)
            throw new Error("The parameter 'mutationSubscriberFlag' cannot be null.");
        else if (mutationSubscriberFlag !== undefined)
            url_ += "mutationSubscriberFlag=" + encodeURIComponent("" + mutationSubscriberFlag) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: Response): Promise<number[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number[]>(null as any);
    }
}

export class TerrainTilesClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the terrain tile as a quantisized mesh
     * @param zoom The zoom level
     * @param x X index
     * @param y Y index
     * @param requestType The request type
     * @param id Identifier of the space or query
     * @param requestDateTime The datetime to request the terrain tile for
     */
    terrain(zoom: number, x: number, y: number, requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TerrainTiles/{zoom}/{x}/{y}/{requestType}/{id}/{requestDateTime}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTerrain(_response);
        });
    }

    protected processTerrain(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get terrain tile layer information
     */
    getLayerInfo(requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<LayerInfo> {
        let url_ = this.baseUrl + "/api/TerrainTiles/{requestType}/{id}/{requestDateTime}/layer.json";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLayerInfo(_response);
        });
    }

    protected processGetLayerInfo(response: Response): Promise<LayerInfo> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LayerInfo.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LayerInfo>(null as any);
    }

    /**
     * Get the terrain tile for debugging purposes, 
    the quantisized mesh projected on top of the raster tile image
     * @param zoom The zoom level
     * @param x X index
     * @param y Y index
     * @param requestType The request type
     * @param id Identifier of the space or query
     * @param requestDateTime The datetime to request the terrain tile for
     */
    debug(zoom: number, x: number, y: number, requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/TerrainTiles/debug/{zoom}/{x}/{y}/{requestType}/{id}/{requestDateTime}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDebug(_response);
        });
    }

    protected processDebug(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class VectorTilesClient extends SpacesClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(configuration: SpacesClientConfig, baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super(configuration);
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get the image tile for a feature as png
     * @param zoom MVT Zoom level
     * @param x MVT x index
     * @param y MVT y index
     * @param id Identifier of the feature requested
     * @param version The version number of the requested feature
     */
    getTileImagesForFeature(zoom: number, x: number, y: number, id: number, version: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/VectorTiles/image-tiles/{zoom}/{x}/{y}/{id}/{version}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTileImagesForFeature(_response);
        });
    }

    protected processGetTileImagesForFeature(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the child features as MVT for a certain date.
     * @param zoom MVT Zoom level
     * @param x MVT x index
     * @param y MVT y index
     * @param requestType MVT Request Type
     * @param id Identifier of the space, aggregate feature or query).
     * @param requestDateTime Date Time  to request MVT for (optional)
     */
    getMvtForSpaceByDate(zoom: number, x: number, y: number, requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-for-space/{zoom}/{x}/{y}/{requestType}/{id}/{requestDateTime}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMvtForSpaceByDate(_response);
        });
    }

    protected processGetMvtForSpaceByDate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * /// Get the child features as MVT.
     * @param zoom MVT Zoom level
     * @param x MVT x index
     * @param y MVT y index
     * @param requestType MVT Request Type
     * @param id Identifier of the space, aggregate feature or query).
     */
    getMvtForSpace(zoom: number, x: number, y: number, requestType: SpacesRequestType, id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-for-space/{zoom}/{x}/{y}/{requestType}/{id}";
        if (zoom === undefined || zoom === null)
            throw new Error("The parameter 'zoom' must be defined.");
        url_ = url_.replace("{zoom}", encodeURIComponent("" + zoom));
        if (x === undefined || x === null)
            throw new Error("The parameter 'x' must be defined.");
        url_ = url_.replace("{x}", encodeURIComponent("" + x));
        if (y === undefined || y === null)
            throw new Error("The parameter 'y' must be defined.");
        url_ = url_.replace("{y}", encodeURIComponent("" + y));
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMvtForSpace(_response);
        });
    }

    protected processGetMvtForSpace(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 204) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * Get the style for the MVT layers.
     * @param requestType (optional) MVT request type
     * @param id (optional) Id for space or query
     * @param baseUri (optional) Uri for local endpoint.
     * @param requestDateTime (optional) Get vector tiles for this date
     */
    getMvtStyle(requestType: SpacesRequestType | undefined, id: number | undefined, baseUri: string | null | undefined, requestDateTime: moment.Moment | null | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-style?";
        if (requestType === null)
            throw new Error("The parameter 'requestType' cannot be null.");
        else if (requestType !== undefined)
            url_ += "requestType=" + encodeURIComponent("" + requestType) + "&";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        if (baseUri !== undefined && baseUri !== null)
            url_ += "baseUri=" + encodeURIComponent("" + baseUri) + "&";
        if (requestDateTime !== undefined && requestDateTime !== null)
            url_ += "requestDateTime=" + encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetMvtStyle(_response);
        });
    }

    protected processGetMvtStyle(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSpriteImage(requestType: SpacesRequestType, id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-sprite/{requestType}/{id}/sprite.png";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpriteImage(_response);
        });
    }

    protected processGetSpriteImage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSpriteImage2(requestType: SpacesRequestType, id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-sprite/{requestType}/{id}/sprite@2x.png";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpriteImage2(_response);
        });
    }

    protected processGetSpriteImage2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSpriteImageByDate(requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-sprite/{requestType}/{id}/{requestDateTime}/sprite.png";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpriteImageByDate(_response);
        });
    }

    protected processGetSpriteImageByDate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSpriteImageByDate2(requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-sprite/{requestType}/{id}/{requestDateTime}/sprite@2x.png";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpriteImageByDate2(_response);
        });
    }

    protected processGetSpriteImageByDate2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSpriteJson(requestType: SpacesRequestType, id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-sprite/{requestType}/{id}/sprite.json";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpriteJson(_response);
        });
    }

    protected processGetSpriteJson(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSpriteJson2(requestType: SpacesRequestType, id: number): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-sprite/{requestType}/{id}/sprite@2x.json";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpriteJson2(_response);
        });
    }

    protected processGetSpriteJson2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSpriteJsonByDate(requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-sprite/{requestType}/{id}/{requestDateTime}/sprite.json";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpriteJsonByDate(_response);
        });
    }

    protected processGetSpriteJsonByDate(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getSpriteJsonByDate2(requestType: SpacesRequestType, id: number, requestDateTime: moment.Moment): Promise<string> {
        let url_ = this.baseUrl + "/api/VectorTiles/mvt-sprite/{requestType}/{id}/{requestDateTime}/sprite@2x.json";
        if (requestType === undefined || requestType === null)
            throw new Error("The parameter 'requestType' must be defined.");
        url_ = url_.replace("{requestType}", encodeURIComponent("" + requestType));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (requestDateTime === undefined || requestDateTime === null)
            throw new Error("The parameter 'requestDateTime' must be defined.");
        url_ = url_.replace("{requestDateTime}", encodeURIComponent(requestDateTime ? "" + requestDateTime.toISOString() : "null"));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetSpriteJsonByDate2(_response);
        });
    }

    protected processGetSpriteJsonByDate2(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getIcons(): Promise<IconDTO[]> {
        let url_ = this.baseUrl + "/api/VectorTiles/get-icons";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetIcons(_response);
        });
    }

    protected processGetIcons(response: Response): Promise<IconDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IconDTO.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            return throwException("Unauthorized", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("Forbidden", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IconDTO[]>(null as any);
    }
}

export class AggregateDTO implements IAggregateDTO {
    /** Only set on serverside */
    spaceId!: number;
    /** Only set on serverside */
    featureId!: number;
    /** Only set on serverside */
    versionNr!: number;
    /** If not set client side, this will default to created date (AGGREGATE only) */
    versionStartDate?: moment.Moment | undefined;
    /** Only set on serverside */
    versionEndDate?: moment.Moment | undefined;
    name?: string | undefined;
    description?: string | undefined;
    /** Only set on serverside */
    tenant?: string | undefined;
    /** Only set on serverside */
    userId?: string | undefined;
    /** Only set on serverside */
    createdDate!: moment.Moment;
    /** Only set on serverside */
    modifiedDate?: moment.Moment | undefined;
    properties?: PropertyDictionary | undefined;
    /** The BoundingBox of all the aggregate geometries combined.
Only set on serverside */
    geometry?: any | undefined;
    symbology?: SymbologyDTO | undefined;
    children?: AggregateNodeDTO[] | undefined;

    constructor(data?: IAggregateDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceId = _data["spaceId"];
            this.featureId = _data["featureId"];
            this.versionNr = _data["versionNr"];
            this.versionStartDate = _data["versionStartDate"] ? moment(_data["versionStartDate"].toString()) : <any>undefined;
            this.versionEndDate = _data["versionEndDate"] ? moment(_data["versionEndDate"].toString()) : <any>undefined;
            this.name = _data["name"];
            this.description = _data["description"];
            this.tenant = _data["tenant"];
            this.userId = _data["userId"];
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? moment(_data["modifiedDate"].toString()) : <any>undefined;
            this.properties = _data["properties"] ? PropertyDictionary.fromJS(_data["properties"]) : <any>undefined;
            this.geometry = _data["geometry"];
            this.symbology = _data["symbology"] ? SymbologyDTO.fromJS(_data["symbology"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AggregateNodeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AggregateDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        data["featureId"] = this.featureId;
        data["versionNr"] = this.versionNr;
        data["versionStartDate"] = this.versionStartDate ? this.versionStartDate.toISOString() : <any>undefined;
        data["versionEndDate"] = this.versionEndDate ? this.versionEndDate.toISOString() : <any>undefined;
        data["name"] = this.name;
        data["description"] = this.description;
        data["tenant"] = this.tenant;
        data["userId"] = this.userId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["geometry"] = this.geometry;
        data["symbology"] = this.symbology ? this.symbology.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAggregateDTO {
    /** Only set on serverside */
    spaceId: number;
    /** Only set on serverside */
    featureId: number;
    /** Only set on serverside */
    versionNr: number;
    /** If not set client side, this will default to created date (AGGREGATE only) */
    versionStartDate?: moment.Moment | undefined;
    /** Only set on serverside */
    versionEndDate?: moment.Moment | undefined;
    name?: string | undefined;
    description?: string | undefined;
    /** Only set on serverside */
    tenant?: string | undefined;
    /** Only set on serverside */
    userId?: string | undefined;
    /** Only set on serverside */
    createdDate: moment.Moment;
    /** Only set on serverside */
    modifiedDate?: moment.Moment | undefined;
    properties?: PropertyDictionary | undefined;
    /** The BoundingBox of all the aggregate geometries combined.
Only set on serverside */
    geometry?: any | undefined;
    symbology?: SymbologyDTO | undefined;
    children?: AggregateNodeDTO[] | undefined;
}

export class PropertyDictionary implements IPropertyDictionary {

    [key: string]: BaseProperty | any;

    constructor(data?: IPropertyDictionary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
        }
    }

    static fromJS(data: any): PropertyDictionary {
        data = typeof data === 'object' ? data : {};
        let result = new PropertyDictionary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        return data;
    }
}

export interface IPropertyDictionary {

    [key: string]: BaseProperty | any;
}

export abstract class BaseProperty implements IBaseProperty {

    protected _discriminator: string;

    constructor(data?: IBaseProperty) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseProperty";
    }

    init(_data?: any) {
    }

    static fromJS(data: any): BaseProperty {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "IntProperty") {
            let result = new IntProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IntSetProperty") {
            let result = new IntSetProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DoubleProperty") {
            let result = new DoubleProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DoubleSetProperty") {
            let result = new DoubleSetProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StringProperty") {
            let result = new StringProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StringSetProperty") {
            let result = new StringSetProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "BooleanProperty") {
            let result = new BooleanProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "BooleanSetProperty") {
            let result = new BooleanSetProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimeProperty") {
            let result = new DateTimeProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DateTimeSetProperty") {
            let result = new DateTimeSetProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "GuidProperty") {
            let result = new GuidProperty();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "GuidSetProperty") {
            let result = new GuidSetProperty();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseProperty' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        return data;
    }
}

export interface IBaseProperty {
}

export class IntProperty extends BaseProperty implements IIntProperty {
    type?: PropertyType;
    value!: number;

    constructor(data?: IIntProperty) {
        super(data);
        this._discriminator = "IntProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): IntProperty {
        data = typeof data === 'object' ? data : {};
        let result = new IntProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IIntProperty extends IBaseProperty {
    type?: PropertyType;
    value: number;
}

export enum PropertyType {
    Int = 0,
    IntSet = 1,
    Double = 2,
    DoubleSet = 3,
    String = 4,
    StringSet = 5,
    Boolean = 6,
    BooleanSet = 7,
    DateTime = 8,
    DateTimeSet = 9,
    Guid = 10,
    GuidSet = 11,
}

export class IntSetProperty extends BaseProperty implements IIntSetProperty {
    type?: PropertyType;
    values!: number[];

    constructor(data?: IIntSetProperty) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "IntSetProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): IntSetProperty {
        data = typeof data === 'object' ? data : {};
        let result = new IntSetProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IIntSetProperty extends IBaseProperty {
    type?: PropertyType;
    values: number[];
}

export class DoubleProperty extends BaseProperty implements IDoubleProperty {
    type?: PropertyType;
    value!: number;

    constructor(data?: IDoubleProperty) {
        super(data);
        this._discriminator = "DoubleProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): DoubleProperty {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IDoubleProperty extends IBaseProperty {
    type?: PropertyType;
    value: number;
}

export class DoubleSetProperty extends BaseProperty implements IDoubleSetProperty {
    type?: PropertyType;
    values!: number[];

    constructor(data?: IDoubleSetProperty) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "DoubleSetProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): DoubleSetProperty {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleSetProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDoubleSetProperty extends IBaseProperty {
    type?: PropertyType;
    values: number[];
}

export class StringProperty extends BaseProperty implements IStringProperty {
    type?: PropertyType;
    value!: string;

    constructor(data?: IStringProperty) {
        super(data);
        this._discriminator = "StringProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): StringProperty {
        data = typeof data === 'object' ? data : {};
        let result = new StringProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IStringProperty extends IBaseProperty {
    type?: PropertyType;
    value: string;
}

export class StringSetProperty extends BaseProperty implements IStringSetProperty {
    type?: PropertyType;
    values!: string[];

    constructor(data?: IStringSetProperty) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "StringSetProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): StringSetProperty {
        data = typeof data === 'object' ? data : {};
        let result = new StringSetProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStringSetProperty extends IBaseProperty {
    type?: PropertyType;
    values: string[];
}

export class BooleanProperty extends BaseProperty implements IBooleanProperty {
    type?: PropertyType;
    value!: boolean;

    constructor(data?: IBooleanProperty) {
        super(data);
        this._discriminator = "BooleanProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BooleanProperty {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanProperty extends IBaseProperty {
    type?: PropertyType;
    value: boolean;
}

export class BooleanSetProperty extends BaseProperty implements IBooleanSetProperty {
    type?: PropertyType;
    values!: boolean[];

    constructor(data?: IBooleanSetProperty) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "BooleanSetProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): BooleanSetProperty {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanSetProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanSetProperty extends IBaseProperty {
    type?: PropertyType;
    values: boolean[];
}

export class DateTimeProperty extends BaseProperty implements IDateTimeProperty {
    type?: PropertyType;
    value!: moment.Moment;

    constructor(data?: IDateTimeProperty) {
        super(data);
        this._discriminator = "DateTimeProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"] ? moment(_data["value"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateTimeProperty {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value ? this.value.toISOString() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimeProperty extends IBaseProperty {
    type?: PropertyType;
    value: moment.Moment;
}

export class DateTimeSetProperty extends BaseProperty implements IDateTimeSetProperty {
    type?: PropertyType;
    values!: moment.Moment[];

    constructor(data?: IDateTimeSetProperty) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "DateTimeSetProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(moment(item));
            }
        }
    }

    static fromJS(data: any): DateTimeSetProperty {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeSetProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toISOString());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimeSetProperty extends IBaseProperty {
    type?: PropertyType;
    values: moment.Moment[];
}

export class GuidProperty extends BaseProperty implements IGuidProperty {
    type?: PropertyType;
    value!: string;

    constructor(data?: IGuidProperty) {
        super(data);
        this._discriminator = "GuidProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): GuidProperty {
        data = typeof data === 'object' ? data : {};
        let result = new GuidProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IGuidProperty extends IBaseProperty {
    type?: PropertyType;
    value: string;
}

export class GuidSetProperty extends BaseProperty implements IGuidSetProperty {
    type?: PropertyType;
    values!: string[];

    constructor(data?: IGuidSetProperty) {
        super(data);
        if (!data) {
            this.values = [];
        }
        this._discriminator = "GuidSetProperty";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.type = _data["type"];
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): GuidSetProperty {
        data = typeof data === 'object' ? data : {};
        let result = new GuidSetProperty();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGuidSetProperty extends IBaseProperty {
    type?: PropertyType;
    values: string[];
}

export class SymbologyDTO implements ISymbologyDTO {
    labelVisible?: boolean | undefined;
    labelRotation?: number | undefined;
    labelAnchor?: string | undefined;

    protected _discriminator: string;

    constructor(data?: ISymbologyDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "SymbologyDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.labelVisible = _data["labelVisible"];
            this.labelRotation = _data["labelRotation"];
            this.labelAnchor = _data["labelAnchor"];
        }
    }

    static fromJS(data: any): SymbologyDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "PointSymbologyDTO") {
            let result = new PointSymbologyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LineSymbologyDTO") {
            let result = new LineSymbologyDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AreaSymbologyDTO") {
            let result = new AreaSymbologyDTO();
            result.init(data);
            return result;
        }
        let result = new SymbologyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["labelVisible"] = this.labelVisible;
        data["labelRotation"] = this.labelRotation;
        data["labelAnchor"] = this.labelAnchor;
        return data;
    }
}

export interface ISymbologyDTO {
    labelVisible?: boolean | undefined;
    labelRotation?: number | undefined;
    labelAnchor?: string | undefined;
}

export class PointSymbologyDTO extends SymbologyDTO implements IPointSymbologyDTO {
    iconId?: number | undefined;
    iconUrl?: string | undefined;

    constructor(data?: IPointSymbologyDTO) {
        super(data);
        this._discriminator = "PointSymbologyDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.iconId = _data["iconId"];
            this.iconUrl = _data["iconUrl"];
        }
    }

    static fromJS(data: any): PointSymbologyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PointSymbologyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iconId"] = this.iconId;
        data["iconUrl"] = this.iconUrl;
        super.toJSON(data);
        return data;
    }
}

export interface IPointSymbologyDTO extends ISymbologyDTO {
    iconId?: number | undefined;
    iconUrl?: string | undefined;
}

export class LineSymbologyDTO extends SymbologyDTO implements ILineSymbologyDTO {
    style?: LineDash;
    width?: number;
    color?: number;

    constructor(data?: ILineSymbologyDTO) {
        super(data);
        this._discriminator = "LineSymbologyDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.style = _data["style"];
            this.width = _data["width"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): LineSymbologyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LineSymbologyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["style"] = this.style;
        data["width"] = this.width;
        data["color"] = this.color;
        super.toJSON(data);
        return data;
    }
}

export interface ILineSymbologyDTO extends ISymbologyDTO {
    style?: LineDash;
    width?: number;
    color?: number;
}

export enum LineDash {
    Solid = 0,
    Dashed = 1,
    Dotted = 2,
}

export class AreaSymbologyDTO extends SymbologyDTO implements IAreaSymbologyDTO {
    color?: number;
    lineColor?: number;

    constructor(data?: IAreaSymbologyDTO) {
        super(data);
        this._discriminator = "AreaSymbologyDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.color = _data["color"];
            this.lineColor = _data["lineColor"];
        }
    }

    static fromJS(data: any): AreaSymbologyDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AreaSymbologyDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["color"] = this.color;
        data["lineColor"] = this.lineColor;
        super.toJSON(data);
        return data;
    }
}

export interface IAreaSymbologyDTO extends ISymbologyDTO {
    color?: number;
    lineColor?: number;
}

export class AggregateNodeDTO implements IAggregateNodeDTO {
    /** Only set on serverside */
    featureId!: number;
    name?: string | undefined;
    description?: string | undefined;
    /** Only set on serverside */
    featureType!: FeatureType;
    properties?: PropertyDictionary | undefined;
    geometry?: any | undefined;
    symbology?: SymbologyDTO | undefined;
    children?: AggregateNodeDTO[] | undefined;

    constructor(data?: IAggregateNodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureId = _data["featureId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.featureType = _data["featureType"];
            this.properties = _data["properties"] ? PropertyDictionary.fromJS(_data["properties"]) : <any>undefined;
            this.geometry = _data["geometry"];
            this.symbology = _data["symbology"] ? SymbologyDTO.fromJS(_data["symbology"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(AggregateNodeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AggregateNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureId"] = this.featureId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["featureType"] = this.featureType;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["geometry"] = this.geometry;
        data["symbology"] = this.symbology ? this.symbology.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAggregateNodeDTO {
    /** Only set on serverside */
    featureId: number;
    name?: string | undefined;
    description?: string | undefined;
    /** Only set on serverside */
    featureType: FeatureType;
    properties?: PropertyDictionary | undefined;
    geometry?: any | undefined;
    symbology?: SymbologyDTO | undefined;
    children?: AggregateNodeDTO[] | undefined;
}

export enum FeatureType {
    ST_Point = 1,
    ST_MultiPoint = 2,
    ST_LineString = 3,
    ST_MultiLineString = 4,
    ST_Polygon = 5,
    ST_MultiPolygon = 6,
    AGGREGATE = 7,
    AGGPART = 8,
    ITEM = 9,
    TILE_IMAGE = 10,
    TILE_RASTER = 11,
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export enum SpaceGeometryReturnType {
    None = 0,
    BoundingBox = 1,
    Full = 2,
}

export class AggregateVersionDTO implements IAggregateVersionDTO {
    versionNr!: number;
    userId?: string | undefined;
    createdDate!: moment.Moment;
    versionStartDate!: moment.Moment;
    versionEndDate?: moment.Moment | undefined;

    constructor(data?: IAggregateVersionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.versionNr = _data["versionNr"];
            this.userId = _data["userId"];
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.versionStartDate = _data["versionStartDate"] ? moment(_data["versionStartDate"].toString()) : <any>undefined;
            this.versionEndDate = _data["versionEndDate"] ? moment(_data["versionEndDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): AggregateVersionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new AggregateVersionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["versionNr"] = this.versionNr;
        data["userId"] = this.userId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["versionStartDate"] = this.versionStartDate ? this.versionStartDate.toISOString() : <any>undefined;
        data["versionEndDate"] = this.versionEndDate ? this.versionEndDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IAggregateVersionDTO {
    versionNr: number;
    userId?: string | undefined;
    createdDate: moment.Moment;
    versionStartDate: moment.Moment;
    versionEndDate?: moment.Moment | undefined;
}

export class HttpValidationProblemDetails extends ProblemDetails implements IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    constructor(data?: IHttpValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): HttpValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new HttpValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IHttpValidationProblemDetails extends IProblemDetails {
    errors?: { [key: string]: string[]; };
}

export class ValidationProblemDetails extends HttpValidationProblemDetails implements IValidationProblemDetails {
    errors?: { [key: string]: string[]; };

    constructor(data?: IValidationProblemDetails) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): ValidationProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ValidationProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        super.toJSON(data);
        return data;
    }
}

export interface IValidationProblemDetails extends IHttpValidationProblemDetails {
    errors?: { [key: string]: string[]; };
}

export enum MutationSubscriberTypes {
    None = 0,
    LogMutation = 1,
    ConsoleMutation = 2,
    ServicebusMutation = 4,
    All = -1,
}

export class SpaceNodeDTO implements ISpaceNodeDTO {
    spaceId!: number;
    name?: string | undefined;
    description?: string | undefined;
    spaceType!: SpaceType;
    tenant?: string | undefined;
    userId?: string | undefined;
    /** All the properties of the parent properties combined. */
    parentProperties?: PropertyDictionary | undefined;
    properties?: PropertyDictionary | undefined;
    accessType!: SpacePermissionType;
    parentSpaceId?: number | undefined;
    featureId?: number | undefined;
    featureType?: FeatureType | undefined;
    versionNr?: number | undefined;
    /** The geometry of the feature.
Only present when this is a "link" to a feature.
This is only filled when this is requested by the endpoint. */
    geometry?: any | undefined;
    /** Symbology for the geometry.
This is only filled when the geometry is requested by the endpoint. */
    symbology?: SymbologyDTO | undefined;
    /** Is this space an aggregate? */
    isAggregate!: boolean;
    /** Is this SpaceNode traversable?
Under normal conditions you would not traverse further down the tree, when the space is not traversable.   */
    isTraversable!: boolean;
    createdDate!: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    path?: PathSegmentOfSpaceType[] | undefined;

    constructor(data?: ISpaceNodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceId = _data["spaceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.spaceType = _data["spaceType"];
            this.tenant = _data["tenant"];
            this.userId = _data["userId"];
            this.parentProperties = _data["parentProperties"] ? PropertyDictionary.fromJS(_data["parentProperties"]) : <any>undefined;
            this.properties = _data["properties"] ? PropertyDictionary.fromJS(_data["properties"]) : <any>undefined;
            this.accessType = _data["accessType"];
            this.parentSpaceId = _data["parentSpaceId"];
            this.featureId = _data["featureId"];
            this.featureType = _data["featureType"];
            this.versionNr = _data["versionNr"];
            this.geometry = _data["geometry"];
            this.symbology = _data["symbology"] ? SymbologyDTO.fromJS(_data["symbology"]) : <any>undefined;
            this.isAggregate = _data["isAggregate"];
            this.isTraversable = _data["isTraversable"];
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? moment(_data["modifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(PathSegmentOfSpaceType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpaceNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["spaceType"] = this.spaceType;
        data["tenant"] = this.tenant;
        data["userId"] = this.userId;
        data["parentProperties"] = this.parentProperties ? this.parentProperties.toJSON() : <any>undefined;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["accessType"] = this.accessType;
        data["parentSpaceId"] = this.parentSpaceId;
        data["featureId"] = this.featureId;
        data["featureType"] = this.featureType;
        data["versionNr"] = this.versionNr;
        data["geometry"] = this.geometry;
        data["symbology"] = this.symbology ? this.symbology.toJSON() : <any>undefined;
        data["isAggregate"] = this.isAggregate;
        data["isTraversable"] = this.isTraversable;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISpaceNodeDTO {
    spaceId: number;
    name?: string | undefined;
    description?: string | undefined;
    spaceType: SpaceType;
    tenant?: string | undefined;
    userId?: string | undefined;
    /** All the properties of the parent properties combined. */
    parentProperties?: PropertyDictionary | undefined;
    properties?: PropertyDictionary | undefined;
    accessType: SpacePermissionType;
    parentSpaceId?: number | undefined;
    featureId?: number | undefined;
    featureType?: FeatureType | undefined;
    versionNr?: number | undefined;
    /** The geometry of the feature.
Only present when this is a "link" to a feature.
This is only filled when this is requested by the endpoint. */
    geometry?: any | undefined;
    /** Symbology for the geometry.
This is only filled when the geometry is requested by the endpoint. */
    symbology?: SymbologyDTO | undefined;
    /** Is this space an aggregate? */
    isAggregate: boolean;
    /** Is this SpaceNode traversable?
Under normal conditions you would not traverse further down the tree, when the space is not traversable.   */
    isTraversable: boolean;
    createdDate: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    path?: PathSegmentOfSpaceType[] | undefined;
}

export enum SpaceType {
    CART_ROOT = 1,
    TENANT_ROOT = 2,
    USER_ROOT = 3,
    SPACE = 4,
    FEATURE = 5,
    JUNCTION = 6,
}

export enum SpacePermissionType {
    R = 1,
    W = 2,
    A = 3,
}

export class PathSegmentOfSpaceType implements IPathSegmentOfSpaceType {
    id!: number;
    name?: string | undefined;
    type!: SpaceType;
    accessType!: SpacePermissionType;

    constructor(data?: IPathSegmentOfSpaceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.accessType = _data["accessType"];
        }
    }

    static fromJS(data: any): PathSegmentOfSpaceType {
        data = typeof data === 'object' ? data : {};
        let result = new PathSegmentOfSpaceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["accessType"] = this.accessType;
        return data;
    }
}

export interface IPathSegmentOfSpaceType {
    id: number;
    name?: string | undefined;
    type: SpaceType;
    accessType: SpacePermissionType;
}

/** A definition of a bulk mutation, which is the create or update of en entire sub tree. - moving a node  when updating is not allowed. */
export class BulkMutationDTO implements IBulkMutationDTO {
    /** The destination of the mutation. */
    destination!: number;
    /** The items to mutate. */
    items!: BaseMutationNodeDTO[];

    constructor(data?: IBulkMutationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.items = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.destination = _data["destination"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(BaseMutationNodeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BulkMutationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new BulkMutationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["destination"] = this.destination;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

/** A definition of a bulk mutation, which is the create or update of en entire sub tree. - moving a node  when updating is not allowed. */
export interface IBulkMutationDTO {
    /** The destination of the mutation. */
    destination: number;
    /** The items to mutate. */
    items: BaseMutationNodeDTO[];
}

export abstract class BaseMutationNodeDTO implements IBaseMutationNodeDTO {
    /** A reference to the node.
- The client needs to set this, the server is oblivious to it.
- It must be unique wihtin the bulk muation
- The client can use is as reference when 
the created nodes are returned by the server. */
    nodeReference!: number;

    protected _discriminator: string;

    constructor(data?: IBaseMutationNodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseMutationNodeDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.nodeReference = _data["nodeReference"];
        }
    }

    static fromJS(data: any): BaseMutationNodeDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SpaceMutationNodeDTO") {
            let result = new SpaceMutationNodeDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "SpaceJunctionMutationNodeDTO") {
            let result = new SpaceJunctionMutationNodeDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FeatureMutationNodeDTO") {
            let result = new FeatureMutationNodeDTO();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseMutationNodeDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["nodeReference"] = this.nodeReference;
        return data;
    }
}

export interface IBaseMutationNodeDTO {
    /** A reference to the node.
- The client needs to set this, the server is oblivious to it.
- It must be unique wihtin the bulk muation
- The client can use is as reference when 
the created nodes are returned by the server. */
    nodeReference: number;
}

export class SpaceMutationNodeDTO extends BaseMutationNodeDTO implements ISpaceMutationNodeDTO {
    space?: SpaceDTO | undefined;
    children?: BaseMutationNodeDTO[] | undefined;

    constructor(data?: ISpaceMutationNodeDTO) {
        super(data);
        this._discriminator = "SpaceMutationNodeDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.space = _data["space"] ? SpaceDTO.fromJS(_data["space"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BaseMutationNodeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpaceMutationNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceMutationNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["space"] = this.space ? this.space.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISpaceMutationNodeDTO extends IBaseMutationNodeDTO {
    space?: SpaceDTO | undefined;
    children?: BaseMutationNodeDTO[] | undefined;
}

export class SpaceDTO implements ISpaceDTO {
    /** The identifier of the space */
    spaceId!: number;
    name!: string;
    description?: string | undefined;
    /** Properties of the space */
    properties?: PropertyDictionary | undefined;
    /** Indication if this space is traversable under normal conditions.
Only set this property when appropriate other wise do not set a value.
When no value is set and this is a create it wil default to true.  */
    isTraversable?: boolean | undefined;

    constructor(data?: ISpaceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceId = _data["spaceId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.properties = _data["properties"] ? PropertyDictionary.fromJS(_data["properties"]) : <any>undefined;
            this.isTraversable = _data["isTraversable"];
        }
    }

    static fromJS(data: any): SpaceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["isTraversable"] = this.isTraversable;
        return data;
    }
}

export interface ISpaceDTO {
    /** The identifier of the space */
    spaceId: number;
    name: string;
    description?: string | undefined;
    /** Properties of the space */
    properties?: PropertyDictionary | undefined;
    /** Indication if this space is traversable under normal conditions.
Only set this property when appropriate other wise do not set a value.
When no value is set and this is a create it wil default to true.  */
    isTraversable?: boolean | undefined;
}

export class SpaceJunctionMutationNodeDTO extends BaseMutationNodeDTO implements ISpaceJunctionMutationNodeDTO {
    feature?: BaseFeatureDTO | undefined;
    children!: BaseMutationNodeDTO[];

    constructor(data?: ISpaceJunctionMutationNodeDTO) {
        super(data);
        if (!data) {
            this.children = [];
        }
        this._discriminator = "SpaceJunctionMutationNodeDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.feature = _data["feature"] ? BaseFeatureDTO.fromJS(_data["feature"]) : <any>undefined;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(BaseMutationNodeDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SpaceJunctionMutationNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceJunctionMutationNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feature"] = this.feature ? this.feature.toJSON() : <any>undefined;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface ISpaceJunctionMutationNodeDTO extends IBaseMutationNodeDTO {
    feature?: BaseFeatureDTO | undefined;
    children: BaseMutationNodeDTO[];
}

export abstract class BaseFeatureDTO implements IBaseFeatureDTO {
    /** The identifier of the space */
    spaceId!: number;

    protected _discriminator: string;

    constructor(data?: IBaseFeatureDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseFeatureDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.spaceId = _data["spaceId"];
        }
    }

    static fromJS(data: any): BaseFeatureDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "ItemFeatureDTO") {
            let result = new ItemFeatureDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "GeometryFeatureDTO") {
            let result = new GeometryFeatureDTO();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LinkToFeatureDTO") {
            let result = new LinkToFeatureDTO();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseFeatureDTO' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["spaceId"] = this.spaceId;
        return data;
    }
}

export interface IBaseFeatureDTO {
    /** The identifier of the space */
    spaceId: number;
}

/** A feature without geometry */
export class ItemFeatureDTO extends BaseFeatureDTO implements IItemFeatureDTO {
    /** The name of the feature */
    name!: string;
    description?: string | undefined;
    /** Properties of the feature */
    properties?: PropertyDictionary | undefined;

    constructor(data?: IItemFeatureDTO) {
        super(data);
        this._discriminator = "ItemFeatureDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.properties = _data["properties"] ? PropertyDictionary.fromJS(_data["properties"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ItemFeatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ItemFeatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** A feature without geometry */
export interface IItemFeatureDTO extends IBaseFeatureDTO {
    /** The name of the feature */
    name: string;
    description?: string | undefined;
    /** Properties of the feature */
    properties?: PropertyDictionary | undefined;
}

/** A feature with a geometry */
export class GeometryFeatureDTO extends BaseFeatureDTO implements IGeometryFeatureDTO {
    /** The name of the feature */
    name!: string;
    description?: string | undefined;
    /** Properties of the feature.

- Add the properties that need to be created, updated or removed.
Setting the property to null will remove the property.  */
    properties?: PropertyDictionary | undefined;
    /** The geometry of the feature.

- When creating a feature the geometry is required, but during an update
we assume that the geometry has not changed when geometry is not set.
- When serialized the geometry will be a GeoJson object.
Because the serialized data is a geojson and we do not want to generate 
Code for a nettopologysuite geometry we set the jsonSchemaType to object. */
    geometry?: any | undefined;
    /** The symbology (style) of the geometry.

- This is not required and when left null, 
we assume it does not need to be updated. */
    symbology?: SymbologyDTO | undefined;

    constructor(data?: IGeometryFeatureDTO) {
        super(data);
        this._discriminator = "GeometryFeatureDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            this.properties = _data["properties"] ? PropertyDictionary.fromJS(_data["properties"]) : <any>undefined;
            this.geometry = _data["geometry"];
            this.symbology = _data["symbology"] ? SymbologyDTO.fromJS(_data["symbology"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeometryFeatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new GeometryFeatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["geometry"] = this.geometry;
        data["symbology"] = this.symbology ? this.symbology.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

/** A feature with a geometry */
export interface IGeometryFeatureDTO extends IBaseFeatureDTO {
    /** The name of the feature */
    name: string;
    description?: string | undefined;
    /** Properties of the feature.

- Add the properties that need to be created, updated or removed.
Setting the property to null will remove the property.  */
    properties?: PropertyDictionary | undefined;
    /** The geometry of the feature.

- When creating a feature the geometry is required, but during an update
we assume that the geometry has not changed when geometry is not set.
- When serialized the geometry will be a GeoJson object.
Because the serialized data is a geojson and we do not want to generate 
Code for a nettopologysuite geometry we set the jsonSchemaType to object. */
    geometry?: any | undefined;
    /** The symbology (style) of the geometry.

- This is not required and when left null, 
we assume it does not need to be updated. */
    symbology?: SymbologyDTO | undefined;
}

export class LinkToFeatureDTO extends BaseFeatureDTO implements ILinkToFeatureDTO {
    /** The identifier of the space */
    spaceId!: number;
    /** Identifier of the feature that needs to be reused and linked to this space  */
    linkToFeatureId!: number;

    constructor(data?: ILinkToFeatureDTO) {
        super(data);
        this._discriminator = "LinkToFeatureDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.spaceId = _data["spaceId"];
            this.linkToFeatureId = _data["linkToFeatureId"];
        }
    }

    static fromJS(data: any): LinkToFeatureDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LinkToFeatureDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        data["linkToFeatureId"] = this.linkToFeatureId;
        super.toJSON(data);
        return data;
    }
}

export interface ILinkToFeatureDTO extends IBaseFeatureDTO {
    /** The identifier of the space */
    spaceId: number;
    /** Identifier of the feature that needs to be reused and linked to this space  */
    linkToFeatureId: number;
}

export class FeatureMutationNodeDTO extends BaseMutationNodeDTO implements IFeatureMutationNodeDTO {
    feature?: BaseFeatureDTO | undefined;

    constructor(data?: IFeatureMutationNodeDTO) {
        super(data);
        this._discriminator = "FeatureMutationNodeDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.feature = _data["feature"] ? BaseFeatureDTO.fromJS(_data["feature"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FeatureMutationNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureMutationNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["feature"] = this.feature ? this.feature.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IFeatureMutationNodeDTO extends IBaseMutationNodeDTO {
    feature?: BaseFeatureDTO | undefined;
}

export class ExportRequestDTO implements IExportRequestDTO {
    /** The name of the exported document */
    name!: string;
    /** The query id to use for export */
    queryId!: number;
    /** The DateTime to use  */
    dateTime!: moment.Moment;
    /** The layers to export */
    layers?: LayerDTO[] | undefined;

    constructor(data?: IExportRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.queryId = _data["queryId"];
            this.dateTime = _data["dateTime"] ? moment(_data["dateTime"].toString()) : <any>undefined;
            if (Array.isArray(_data["layers"])) {
                this.layers = [] as any;
                for (let item of _data["layers"])
                    this.layers!.push(LayerDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ExportRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["queryId"] = this.queryId;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
        if (Array.isArray(this.layers)) {
            data["layers"] = [];
            for (let item of this.layers)
                data["layers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IExportRequestDTO {
    /** The name of the exported document */
    name: string;
    /** The query id to use for export */
    queryId: number;
    /** The DateTime to use  */
    dateTime: moment.Moment;
    /** The layers to export */
    layers?: LayerDTO[] | undefined;
}

export class LayerDTO implements ILayerDTO {
    /** The name of the layer */
    name!: string;
    /** The description of the layer (not required). */
    description?: string | undefined;
    /** The spaceIds of te features that need to be added to the layer  */
    features?: number[] | undefined;

    constructor(data?: ILayerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.description = _data["description"];
            if (Array.isArray(_data["features"])) {
                this.features = [] as any;
                for (let item of _data["features"])
                    this.features!.push(item);
            }
        }
    }

    static fromJS(data: any): LayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LayerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["description"] = this.description;
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item);
        }
        return data;
    }
}

export interface ILayerDTO {
    /** The name of the layer */
    name: string;
    /** The description of the layer (not required). */
    description?: string | undefined;
    /** The spaceIds of te features that need to be added to the layer  */
    features?: number[] | undefined;
}

export class ExternalLayerDTO implements IExternalLayerDTO {
    /** The identifier of the layer */
    externalLayerId!: number;
    /** The layer name. Required. Used in sorting the layers for a tenant */
    layerName?: string | undefined;
    /** Required layer type, e.g. WMS/WMTS */
    layerType!: ExternalLayerType;
    /** Required layer url */
    url?: string | undefined;
    /** optional Capabilities layer url
Some WMTS services use a Capabilities Url that does not conform to the standard conventions */
    capabilitiesUrl?: string | undefined;
    /** optional Matrix Set */
    matrixSet?: string | undefined;
    /** Required layer name (or names as csv) */
    layers?: string | undefined;
    isWritable?: boolean | undefined;

    constructor(data?: IExternalLayerDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalLayerId = _data["externalLayerId"];
            this.layerName = _data["layerName"];
            this.layerType = _data["layerType"];
            this.url = _data["url"];
            this.capabilitiesUrl = _data["capabilitiesUrl"];
            this.matrixSet = _data["matrixSet"];
            this.layers = _data["layers"];
            this.isWritable = _data["isWritable"];
        }
    }

    static fromJS(data: any): ExternalLayerDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ExternalLayerDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalLayerId"] = this.externalLayerId;
        data["layerName"] = this.layerName;
        data["layerType"] = this.layerType;
        data["url"] = this.url;
        data["capabilitiesUrl"] = this.capabilitiesUrl;
        data["matrixSet"] = this.matrixSet;
        data["layers"] = this.layers;
        data["isWritable"] = this.isWritable;
        return data;
    }
}

export interface IExternalLayerDTO {
    /** The identifier of the layer */
    externalLayerId: number;
    /** The layer name. Required. Used in sorting the layers for a tenant */
    layerName?: string | undefined;
    /** Required layer type, e.g. WMS/WMTS */
    layerType: ExternalLayerType;
    /** Required layer url */
    url?: string | undefined;
    /** optional Capabilities layer url
Some WMTS services use a Capabilities Url that does not conform to the standard conventions */
    capabilitiesUrl?: string | undefined;
    /** optional Matrix Set */
    matrixSet?: string | undefined;
    /** Required layer name (or names as csv) */
    layers?: string | undefined;
    isWritable?: boolean | undefined;
}

export enum ExternalLayerType {
    WMS = 1,
    WMTS = 2,
}

export class FeatureNodeDTO implements IFeatureNodeDTO {
    featureId!: number;
    featureName?: string | undefined;
    featureDescription?: string | undefined;
    featureType!: FeatureType;
    tenant?: string | undefined;
    userId?: string | undefined;
    properties?: PropertyDictionary | undefined;
    parentFeatureId?: number | undefined;
    /** The geometry of the feature.
Only present when this is a "link" to a feature.
This is only filled when this is requested by the endpoint. */
    geometry?: any | undefined;
    /** Symbology for the geometry.
This is only filled when the geometry is requested by the endpoint. */
    symbology?: SymbologyDTO | undefined;
    isAggregate!: boolean;
    createdDate!: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    path?: PathSegmentOfFeatureType[] | undefined;

    constructor(data?: IFeatureNodeDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureId = _data["featureId"];
            this.featureName = _data["featureName"];
            this.featureDescription = _data["featureDescription"];
            this.featureType = _data["featureType"];
            this.tenant = _data["tenant"];
            this.userId = _data["userId"];
            this.properties = _data["properties"] ? PropertyDictionary.fromJS(_data["properties"]) : <any>undefined;
            this.parentFeatureId = _data["parentFeatureId"];
            this.geometry = _data["geometry"];
            this.symbology = _data["symbology"] ? SymbologyDTO.fromJS(_data["symbology"]) : <any>undefined;
            this.isAggregate = _data["isAggregate"];
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.modifiedDate = _data["modifiedDate"] ? moment(_data["modifiedDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(PathSegmentOfFeatureType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FeatureNodeDTO {
        data = typeof data === 'object' ? data : {};
        let result = new FeatureNodeDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureId"] = this.featureId;
        data["featureName"] = this.featureName;
        data["featureDescription"] = this.featureDescription;
        data["featureType"] = this.featureType;
        data["tenant"] = this.tenant;
        data["userId"] = this.userId;
        data["properties"] = this.properties ? this.properties.toJSON() : <any>undefined;
        data["parentFeatureId"] = this.parentFeatureId;
        data["geometry"] = this.geometry;
        data["symbology"] = this.symbology ? this.symbology.toJSON() : <any>undefined;
        data["isAggregate"] = this.isAggregate;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["modifiedDate"] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFeatureNodeDTO {
    featureId: number;
    featureName?: string | undefined;
    featureDescription?: string | undefined;
    featureType: FeatureType;
    tenant?: string | undefined;
    userId?: string | undefined;
    properties?: PropertyDictionary | undefined;
    parentFeatureId?: number | undefined;
    /** The geometry of the feature.
Only present when this is a "link" to a feature.
This is only filled when this is requested by the endpoint. */
    geometry?: any | undefined;
    /** Symbology for the geometry.
This is only filled when the geometry is requested by the endpoint. */
    symbology?: SymbologyDTO | undefined;
    isAggregate: boolean;
    createdDate: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    path?: PathSegmentOfFeatureType[] | undefined;
}

export class PathSegmentOfFeatureType implements IPathSegmentOfFeatureType {
    id!: number;
    name?: string | undefined;
    type!: FeatureType;
    accessType!: SpacePermissionType;

    constructor(data?: IPathSegmentOfFeatureType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.type = _data["type"];
            this.accessType = _data["accessType"];
        }
    }

    static fromJS(data: any): PathSegmentOfFeatureType {
        data = typeof data === 'object' ? data : {};
        let result = new PathSegmentOfFeatureType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["type"] = this.type;
        data["accessType"] = this.accessType;
        return data;
    }
}

export interface IPathSegmentOfFeatureType {
    id: number;
    name?: string | undefined;
    type: FeatureType;
    accessType: SpacePermissionType;
}

export class PublishOgcDTO implements IPublishOgcDTO {
    ogcPublishId?: string | undefined;
    ogcPublishName?: string | undefined;

    constructor(data?: IPublishOgcDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ogcPublishId = _data["ogcPublishId"];
            this.ogcPublishName = _data["ogcPublishName"];
        }
    }

    static fromJS(data: any): PublishOgcDTO {
        data = typeof data === 'object' ? data : {};
        let result = new PublishOgcDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ogcPublishId"] = this.ogcPublishId;
        data["ogcPublishName"] = this.ogcPublishName;
        return data;
    }
}

export interface IPublishOgcDTO {
    ogcPublishId?: string | undefined;
    ogcPublishName?: string | undefined;
}

export enum SpacesRequestType {
    Space = 0,
    Query = 1,
}

/** The configuration for the raster data */
export class RasterConfigDTO implements IRasterConfigDTO {
    /** The colorscale to use for coloring the raster data.
- When no colorscale is set, the raw data will be returned. */
    colorScale?: ColorScaleConfigDTO | undefined;
    /** Add hillshading to the raster data. */
    hillShading!: boolean;
    /** The vetical exaggeration to use.
- this will default to 3 when not set. */
    verticalExaggeration!: number;

    constructor(data?: IRasterConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.colorScale = _data["colorScale"] ? ColorScaleConfigDTO.fromJS(_data["colorScale"]) : <any>undefined;
            this.hillShading = _data["hillShading"];
            this.verticalExaggeration = _data["verticalExaggeration"];
        }
    }

    static fromJS(data: any): RasterConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new RasterConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["colorScale"] = this.colorScale ? this.colorScale.toJSON() : <any>undefined;
        data["hillShading"] = this.hillShading;
        data["verticalExaggeration"] = this.verticalExaggeration;
        return data;
    }
}

/** The configuration for the raster data */
export interface IRasterConfigDTO {
    /** The colorscale to use for coloring the raster data.
- When no colorscale is set, the raw data will be returned. */
    colorScale?: ColorScaleConfigDTO | undefined;
    /** Add hillshading to the raster data. */
    hillShading: boolean;
    /** The vetical exaggeration to use.
- this will default to 3 when not set. */
    verticalExaggeration: number;
}

export class ColorScaleConfigDTO implements IColorScaleConfigDTO {
    colorRange?: ColorStopDTO[] | undefined;
    underFlow!: string;
    useGradient!: boolean;

    constructor(data?: IColorScaleConfigDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["colorRange"])) {
                this.colorRange = [] as any;
                for (let item of _data["colorRange"])
                    this.colorRange!.push(ColorStopDTO.fromJS(item));
            }
            this.underFlow = _data["underFlow"];
            this.useGradient = _data["useGradient"];
        }
    }

    static fromJS(data: any): ColorScaleConfigDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ColorScaleConfigDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.colorRange)) {
            data["colorRange"] = [];
            for (let item of this.colorRange)
                data["colorRange"].push(item.toJSON());
        }
        data["underFlow"] = this.underFlow;
        data["useGradient"] = this.useGradient;
        return data;
    }
}

export interface IColorScaleConfigDTO {
    colorRange?: ColorStopDTO[] | undefined;
    underFlow: string;
    useGradient: boolean;
}

export class ColorStopDTO implements IColorStopDTO {
    value!: number;
    color!: string;

    constructor(data?: IColorStopDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.color = _data["color"];
        }
    }

    static fromJS(data: any): ColorStopDTO {
        data = typeof data === 'object' ? data : {};
        let result = new ColorStopDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["color"] = this.color;
        return data;
    }
}

export interface IColorStopDTO {
    value: number;
    color: string;
}

export class CrossProfileDTO implements ICrossProfileDTO {
    featureId!: number;
    spaceId!: number;
    featureName?: string | undefined;
    points?: CrossProfilePointDTO[] | undefined;

    constructor(data?: ICrossProfileDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureId = _data["featureId"];
            this.spaceId = _data["spaceId"];
            this.featureName = _data["featureName"];
            if (Array.isArray(_data["points"])) {
                this.points = [] as any;
                for (let item of _data["points"])
                    this.points!.push(CrossProfilePointDTO.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CrossProfileDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrossProfileDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureId"] = this.featureId;
        data["spaceId"] = this.spaceId;
        data["featureName"] = this.featureName;
        if (Array.isArray(this.points)) {
            data["points"] = [];
            for (let item of this.points)
                data["points"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICrossProfileDTO {
    featureId: number;
    spaceId: number;
    featureName?: string | undefined;
    points?: CrossProfilePointDTO[] | undefined;
}

export class CrossProfilePointDTO implements ICrossProfilePointDTO {
    coordinateIndex!: number;
    location!: any;
    depth?: number | undefined;
    measure!: number;
    surveyDate?: moment.Moment | undefined;

    constructor(data?: ICrossProfilePointDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.coordinateIndex = _data["coordinateIndex"];
            this.location = _data["location"];
            this.depth = _data["depth"];
            this.measure = _data["measure"];
            this.surveyDate = _data["surveyDate"] ? moment(_data["surveyDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): CrossProfilePointDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrossProfilePointDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["coordinateIndex"] = this.coordinateIndex;
        data["location"] = this.location;
        data["depth"] = this.depth;
        data["measure"] = this.measure;
        data["surveyDate"] = this.surveyDate ? this.surveyDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface ICrossProfilePointDTO {
    coordinateIndex: number;
    location: any;
    depth?: number | undefined;
    measure: number;
    surveyDate?: moment.Moment | undefined;
}

export class CrossLineDTO implements ICrossLineDTO {
    crossLine!: any;
    zoomLevel?: number | undefined;
    segmentSize?: number | undefined;

    constructor(data?: ICrossLineDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.crossLine = _data["crossLine"];
            this.zoomLevel = _data["zoomLevel"];
            this.segmentSize = _data["segmentSize"];
        }
    }

    static fromJS(data: any): CrossLineDTO {
        data = typeof data === 'object' ? data : {};
        let result = new CrossLineDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["crossLine"] = this.crossLine;
        data["zoomLevel"] = this.zoomLevel;
        data["segmentSize"] = this.segmentSize;
        return data;
    }
}

export interface ICrossLineDTO {
    crossLine: any;
    zoomLevel?: number | undefined;
    segmentSize?: number | undefined;
}

export class NodeResultOfSpaceNodeDTOAndSpaceType implements INodeResultOfSpaceNodeDTOAndSpaceType {
    items?: SpaceNodeDTO[] | undefined;
    path?: PathSegmentOfSpaceType[] | undefined;
    searchExtent?: SearchExtentDTO | undefined;

    constructor(data?: INodeResultOfSpaceNodeDTOAndSpaceType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(SpaceNodeDTO.fromJS(item));
            }
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(PathSegmentOfSpaceType.fromJS(item));
            }
            this.searchExtent = _data["searchExtent"] ? SearchExtentDTO.fromJS(_data["searchExtent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): NodeResultOfSpaceNodeDTOAndSpaceType {
        data = typeof data === 'object' ? data : {};
        let result = new NodeResultOfSpaceNodeDTOAndSpaceType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item.toJSON());
        }
        data["searchExtent"] = this.searchExtent ? this.searchExtent.toJSON() : <any>undefined;
        return data;
    }
}

export interface INodeResultOfSpaceNodeDTOAndSpaceType {
    items?: SpaceNodeDTO[] | undefined;
    path?: PathSegmentOfSpaceType[] | undefined;
    searchExtent?: SearchExtentDTO | undefined;
}

export class SearchExtentDTO implements ISearchExtentDTO {
    queryId!: number;
    resultCount!: number;
    resultExtent?: any | undefined;

    constructor(data?: ISearchExtentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.queryId = _data["queryId"];
            this.resultCount = _data["resultCount"];
            this.resultExtent = _data["resultExtent"];
        }
    }

    static fromJS(data: any): SearchExtentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchExtentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["queryId"] = this.queryId;
        data["resultCount"] = this.resultCount;
        data["resultExtent"] = this.resultExtent;
        return data;
    }
}

export interface ISearchExtentDTO {
    queryId: number;
    resultCount: number;
    resultExtent?: any | undefined;
}

/** Define the filter and order used on the results of a query. */
export class QueryRequestDTO implements IQueryRequestDTO {
    /** A filter string for "Name" properties, will be resolved to Name or Description or Userid. */
    nameFilter?: string | undefined;
    /** Filter conditions for "Date" properties, will be resolved to Created Date or Modified Date or any of the Date Properties. */
    dateFilter?: DateTimeFilter | undefined;
    /** Filter condition for FeatureType(s). */
    featureTypeFilter?: FeatureType[] | undefined;
    /** Filter condition for FeatureType(s) present within an Aggregate. Only implemented for hierarchy endpoint */
    childFeatureTypeFilter?: FeatureType[] | undefined;
    /** Filter condition for SpaceType(s).  */
    spaceTypeFilter?: SpaceType[] | undefined;
    /** A basic orderby which works only for "column" properties. */
    orderBy?: { [key: string]: string; } | undefined;
    /** A filter for space or feature properties, multiple conditions are combined with AND. */
    propertyFilters?: BaseFilter[] | undefined;
    /** The number of items to skip from the result. */
    skip!: number;
    /** The number of items to return. */
    take!: number;
    /** The ID of the current query. Null will start a new query */
    queryId?: number | undefined;

    protected _discriminator: string;

    constructor(data?: IQueryRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "QueryRequestDTO";
    }

    init(_data?: any) {
        if (_data) {
            this.nameFilter = _data["nameFilter"];
            this.dateFilter = _data["dateFilter"] ? DateTimeFilter.fromJS(_data["dateFilter"]) : <any>undefined;
            if (Array.isArray(_data["featureTypeFilter"])) {
                this.featureTypeFilter = [] as any;
                for (let item of _data["featureTypeFilter"])
                    this.featureTypeFilter!.push(item);
            }
            if (Array.isArray(_data["childFeatureTypeFilter"])) {
                this.childFeatureTypeFilter = [] as any;
                for (let item of _data["childFeatureTypeFilter"])
                    this.childFeatureTypeFilter!.push(item);
            }
            if (Array.isArray(_data["spaceTypeFilter"])) {
                this.spaceTypeFilter = [] as any;
                for (let item of _data["spaceTypeFilter"])
                    this.spaceTypeFilter!.push(item);
            }
            if (_data["orderBy"]) {
                this.orderBy = {} as any;
                for (let key in _data["orderBy"]) {
                    if (_data["orderBy"].hasOwnProperty(key))
                        (<any>this.orderBy)![key] = _data["orderBy"][key];
                }
            }
            if (Array.isArray(_data["propertyFilters"])) {
                this.propertyFilters = [] as any;
                for (let item of _data["propertyFilters"])
                    this.propertyFilters!.push(BaseFilter.fromJS(item));
            }
            this.skip = _data["skip"];
            this.take = _data["take"];
            this.queryId = _data["queryId"];
        }
    }

    static fromJS(data: any): QueryRequestDTO {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "SpatialQueryRequestDTO") {
            let result = new SpatialQueryRequestDTO();
            result.init(data);
            return result;
        }
        let result = new QueryRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["nameFilter"] = this.nameFilter;
        data["dateFilter"] = this.dateFilter ? this.dateFilter.toJSON() : <any>undefined;
        if (Array.isArray(this.featureTypeFilter)) {
            data["featureTypeFilter"] = [];
            for (let item of this.featureTypeFilter)
                data["featureTypeFilter"].push(item);
        }
        if (Array.isArray(this.childFeatureTypeFilter)) {
            data["childFeatureTypeFilter"] = [];
            for (let item of this.childFeatureTypeFilter)
                data["childFeatureTypeFilter"].push(item);
        }
        if (Array.isArray(this.spaceTypeFilter)) {
            data["spaceTypeFilter"] = [];
            for (let item of this.spaceTypeFilter)
                data["spaceTypeFilter"].push(item);
        }
        if (this.orderBy) {
            data["orderBy"] = {};
            for (let key in this.orderBy) {
                if (this.orderBy.hasOwnProperty(key))
                    (<any>data["orderBy"])[key] = (<any>this.orderBy)[key];
            }
        }
        if (Array.isArray(this.propertyFilters)) {
            data["propertyFilters"] = [];
            for (let item of this.propertyFilters)
                data["propertyFilters"].push(item.toJSON());
        }
        data["skip"] = this.skip;
        data["take"] = this.take;
        data["queryId"] = this.queryId;
        return data;
    }
}

/** Define the filter and order used on the results of a query. */
export interface IQueryRequestDTO {
    /** A filter string for "Name" properties, will be resolved to Name or Description or Userid. */
    nameFilter?: string | undefined;
    /** Filter conditions for "Date" properties, will be resolved to Created Date or Modified Date or any of the Date Properties. */
    dateFilter?: DateTimeFilter | undefined;
    /** Filter condition for FeatureType(s). */
    featureTypeFilter?: FeatureType[] | undefined;
    /** Filter condition for FeatureType(s) present within an Aggregate. Only implemented for hierarchy endpoint */
    childFeatureTypeFilter?: FeatureType[] | undefined;
    /** Filter condition for SpaceType(s).  */
    spaceTypeFilter?: SpaceType[] | undefined;
    /** A basic orderby which works only for "column" properties. */
    orderBy?: { [key: string]: string; } | undefined;
    /** A filter for space or feature properties, multiple conditions are combined with AND. */
    propertyFilters?: BaseFilter[] | undefined;
    /** The number of items to skip from the result. */
    skip: number;
    /** The number of items to return. */
    take: number;
    /** The ID of the current query. Null will start a new query */
    queryId?: number | undefined;
}

export abstract class BaseFilter implements IBaseFilter {
    type!: PropertyType;
    acronym?: string | undefined;

    protected _discriminator: string;

    constructor(data?: IBaseFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        this._discriminator = "BaseFilter";
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.acronym = _data["acronym"];
        }
    }

    static fromJS(data: any): BaseFilter {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "DateTimeFilter") {
            let result = new DateTimeFilter();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ExistsFilter") {
            let result = new ExistsFilter();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "DoubleFilter") {
            let result = new DoubleFilter();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "IntFilter") {
            let result = new IntFilter();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "GuidFilter") {
            let result = new GuidFilter();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "BooleanFilter") {
            let result = new BooleanFilter();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "StringFilter") {
            let result = new StringFilter();
            result.init(data);
            return result;
        }
        throw new Error("The abstract class 'BaseFilter' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator;
        data["type"] = this.type;
        data["acronym"] = this.acronym;
        return data;
    }
}

export interface IBaseFilter {
    type: PropertyType;
    acronym?: string | undefined;
}

export class DateTimeFilter extends BaseFilter implements IDateTimeFilter {
    min?: moment.Moment | undefined;
    max?: moment.Moment | undefined;
    inclusive?: boolean;
    between?: boolean;

    constructor(data?: IDateTimeFilter) {
        super(data);
        this._discriminator = "DateTimeFilter";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"] ? moment(_data["min"].toString()) : <any>undefined;
            this.max = _data["max"] ? moment(_data["max"].toString()) : <any>undefined;
            this.inclusive = _data["inclusive"];
            this.between = _data["between"];
        }
    }

    static fromJS(data: any): DateTimeFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DateTimeFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min ? this.min.toISOString() : <any>undefined;
        data["max"] = this.max ? this.max.toISOString() : <any>undefined;
        data["inclusive"] = this.inclusive;
        data["between"] = this.between;
        super.toJSON(data);
        return data;
    }
}

export interface IDateTimeFilter extends IBaseFilter {
    min?: moment.Moment | undefined;
    max?: moment.Moment | undefined;
    inclusive?: boolean;
    between?: boolean;
}

export class ExistsFilter extends BaseFilter implements IExistsFilter {
    exists?: boolean;

    constructor(data?: IExistsFilter) {
        super(data);
        this._discriminator = "ExistsFilter";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.exists = _data["exists"];
        }
    }

    static fromJS(data: any): ExistsFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ExistsFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exists"] = this.exists;
        super.toJSON(data);
        return data;
    }
}

export interface IExistsFilter extends IBaseFilter {
    exists?: boolean;
}

export class DoubleFilter extends BaseFilter implements IDoubleFilter {
    min?: number | undefined;
    max?: number | undefined;
    inclusive?: boolean;
    between?: boolean;

    constructor(data?: IDoubleFilter) {
        super(data);
        this._discriminator = "DoubleFilter";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.min = _data["min"];
            this.max = _data["max"];
            this.inclusive = _data["inclusive"];
            this.between = _data["between"];
        }
    }

    static fromJS(data: any): DoubleFilter {
        data = typeof data === 'object' ? data : {};
        let result = new DoubleFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["min"] = this.min;
        data["max"] = this.max;
        data["inclusive"] = this.inclusive;
        data["between"] = this.between;
        super.toJSON(data);
        return data;
    }
}

export interface IDoubleFilter extends IBaseFilter {
    min?: number | undefined;
    max?: number | undefined;
    inclusive?: boolean;
    between?: boolean;
}

export class IntFilter extends BaseFilter implements IIntFilter {
    values?: number[] | undefined;
    min?: number | undefined;
    max?: number | undefined;
    inclusive?: boolean;
    between?: boolean;

    constructor(data?: IIntFilter) {
        super(data);
        this._discriminator = "IntFilter";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
            this.min = _data["min"];
            this.max = _data["max"];
            this.inclusive = _data["inclusive"];
            this.between = _data["between"];
        }
    }

    static fromJS(data: any): IntFilter {
        data = typeof data === 'object' ? data : {};
        let result = new IntFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        data["min"] = this.min;
        data["max"] = this.max;
        data["inclusive"] = this.inclusive;
        data["between"] = this.between;
        super.toJSON(data);
        return data;
    }
}

export interface IIntFilter extends IBaseFilter {
    values?: number[] | undefined;
    min?: number | undefined;
    max?: number | undefined;
    inclusive?: boolean;
    between?: boolean;
}

export class GuidFilter extends BaseFilter implements IGuidFilter {
    values?: string[] | undefined;

    constructor(data?: IGuidFilter) {
        super(data);
        this._discriminator = "GuidFilter";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): GuidFilter {
        data = typeof data === 'object' ? data : {};
        let result = new GuidFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IGuidFilter extends IBaseFilter {
    values?: string[] | undefined;
}

export class BooleanFilter extends BaseFilter implements IBooleanFilter {
    value?: boolean;

    constructor(data?: IBooleanFilter) {
        super(data);
        this._discriminator = "BooleanFilter";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): BooleanFilter {
        data = typeof data === 'object' ? data : {};
        let result = new BooleanFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        super.toJSON(data);
        return data;
    }
}

export interface IBooleanFilter extends IBaseFilter {
    value?: boolean;
}

export class StringFilter extends BaseFilter implements IStringFilter {
    values?: string[] | undefined;

    constructor(data?: IStringFilter) {
        super(data);
        this._discriminator = "StringFilter";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(item);
            }
        }
    }

    static fromJS(data: any): StringFilter {
        data = typeof data === 'object' ? data : {};
        let result = new StringFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IStringFilter extends IBaseFilter {
    values?: string[] | undefined;
}

/** Define the filter and order used on the results of a query. */
export class SpatialQueryRequestDTO extends QueryRequestDTO implements ISpatialQueryRequestDTO {
    geometry?: any | undefined;

    constructor(data?: ISpatialQueryRequestDTO) {
        super(data);
        this._discriminator = "SpatialQueryRequestDTO";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.geometry = _data["geometry"];
        }
    }

    static fromJS(data: any): SpatialQueryRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpatialQueryRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["geometry"] = this.geometry;
        super.toJSON(data);
        return data;
    }
}

/** Define the filter and order used on the results of a query. */
export interface ISpatialQueryRequestDTO extends IQueryRequestDTO {
    geometry?: any | undefined;
}

export class SpaceExtentDTO implements ISpaceExtentDTO {
    spaceId!: number;
    geometry?: any | undefined;

    constructor(data?: ISpaceExtentDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceId = _data["spaceId"];
            this.geometry = _data["geometry"];
        }
    }

    static fromJS(data: any): SpaceExtentDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceExtentDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        data["geometry"] = this.geometry;
        return data;
    }
}

export interface ISpaceExtentDTO {
    spaceId: number;
    geometry?: any | undefined;
}

export class SearchStoredQueryDTO implements ISearchStoredQueryDTO {
    allResultsQueryId!: number;
    vectorResultsQueryId?: number | undefined;
    rasterResultsQueryId?: number | undefined;

    constructor(data?: ISearchStoredQueryDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.allResultsQueryId = _data["allResultsQueryId"];
            this.vectorResultsQueryId = _data["vectorResultsQueryId"];
            this.rasterResultsQueryId = _data["rasterResultsQueryId"];
        }
    }

    static fromJS(data: any): SearchStoredQueryDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStoredQueryDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["allResultsQueryId"] = this.allResultsQueryId;
        data["vectorResultsQueryId"] = this.vectorResultsQueryId;
        data["rasterResultsQueryId"] = this.rasterResultsQueryId;
        return data;
    }
}

export interface ISearchStoredQueryDTO {
    allResultsQueryId: number;
    vectorResultsQueryId?: number | undefined;
    rasterResultsQueryId?: number | undefined;
}

export class SearchStoreResultDTO implements ISearchStoreResultDTO {
    spaces?: SearchStoreResultSpaceDTO[] | undefined;
    featureTypes?: FeatureType[] | undefined;
    separateQueries?: boolean | undefined;

    constructor(data?: ISearchStoreResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["spaces"])) {
                this.spaces = [] as any;
                for (let item of _data["spaces"])
                    this.spaces!.push(SearchStoreResultSpaceDTO.fromJS(item));
            }
            if (Array.isArray(_data["featureTypes"])) {
                this.featureTypes = [] as any;
                for (let item of _data["featureTypes"])
                    this.featureTypes!.push(item);
            }
            this.separateQueries = _data["separateQueries"];
        }
    }

    static fromJS(data: any): SearchStoreResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStoreResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.spaces)) {
            data["spaces"] = [];
            for (let item of this.spaces)
                data["spaces"].push(item.toJSON());
        }
        if (Array.isArray(this.featureTypes)) {
            data["featureTypes"] = [];
            for (let item of this.featureTypes)
                data["featureTypes"].push(item);
        }
        data["separateQueries"] = this.separateQueries;
        return data;
    }
}

export interface ISearchStoreResultDTO {
    spaces?: SearchStoreResultSpaceDTO[] | undefined;
    featureTypes?: FeatureType[] | undefined;
    separateQueries?: boolean | undefined;
}

export class SearchStoreResultSpaceDTO implements ISearchStoreResultSpaceDTO {
    spaceId!: number;
    featureId?: number | undefined;

    constructor(data?: ISearchStoreResultSpaceDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.spaceId = _data["spaceId"];
            this.featureId = _data["featureId"];
        }
    }

    static fromJS(data: any): SearchStoreResultSpaceDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SearchStoreResultSpaceDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["spaceId"] = this.spaceId;
        data["featureId"] = this.featureId;
        return data;
    }
}

export interface ISearchStoreResultSpaceDTO {
    spaceId: number;
    featureId?: number | undefined;
}

export class SpaceTimelineResultDTO implements ISpaceTimelineResultDTO {
    breaks?: moment.Moment[] | undefined;

    constructor(data?: ISpaceTimelineResultDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["breaks"])) {
                this.breaks = [] as any;
                for (let item of _data["breaks"])
                    this.breaks!.push(moment(item));
            }
        }
    }

    static fromJS(data: any): SpaceTimelineResultDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceTimelineResultDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.breaks)) {
            data["breaks"] = [];
            for (let item of this.breaks)
                data["breaks"].push(item.toISOString());
        }
        return data;
    }
}

export interface ISpaceTimelineResultDTO {
    breaks?: moment.Moment[] | undefined;
}

export class SpaceTimelineRequestDTO implements ISpaceTimelineRequestDTO {
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    resolution!: TimelineResolution;
    maxDepth?: number | undefined;

    constructor(data?: ISpaceTimelineRequestDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.resolution = _data["resolution"];
            this.maxDepth = _data["maxDepth"];
        }
    }

    static fromJS(data: any): SpaceTimelineRequestDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpaceTimelineRequestDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        data["resolution"] = this.resolution;
        data["maxDepth"] = this.maxDepth;
        return data;
    }
}

export interface ISpaceTimelineRequestDTO {
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    resolution: TimelineResolution;
    maxDepth?: number | undefined;
}

export enum TimelineResolution {
    YEAR = 0,
    MONTH = 1,
    DAY = 2,
    HOUR = 3,
    MINUTE = 4,
    SECOND = 5,
}

export class LogDTO implements ILogDTO {
    logId!: number;
    createdDate!: moment.Moment;
    userId?: string | undefined;
    fromSpaceId?: number | undefined;
    spaceId?: number | undefined;
    fromFeatureId?: number | undefined;
    featureId?: number | undefined;
    fromPath?: string | undefined;
    path?: string | undefined;
    fromName?: string | undefined;
    name?: string | undefined;
    message?: string | undefined;
    action!: LogActionType;

    constructor(data?: ILogDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logId = _data["logId"];
            this.createdDate = _data["createdDate"] ? moment(_data["createdDate"].toString()) : <any>undefined;
            this.userId = _data["userId"];
            this.fromSpaceId = _data["fromSpaceId"];
            this.spaceId = _data["spaceId"];
            this.fromFeatureId = _data["fromFeatureId"];
            this.featureId = _data["featureId"];
            this.fromPath = _data["fromPath"];
            this.path = _data["path"];
            this.fromName = _data["fromName"];
            this.name = _data["name"];
            this.message = _data["message"];
            this.action = _data["action"];
        }
    }

    static fromJS(data: any): LogDTO {
        data = typeof data === 'object' ? data : {};
        let result = new LogDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logId"] = this.logId;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
        data["userId"] = this.userId;
        data["fromSpaceId"] = this.fromSpaceId;
        data["spaceId"] = this.spaceId;
        data["fromFeatureId"] = this.fromFeatureId;
        data["featureId"] = this.featureId;
        data["fromPath"] = this.fromPath;
        data["path"] = this.path;
        data["fromName"] = this.fromName;
        data["name"] = this.name;
        data["message"] = this.message;
        data["action"] = this.action;
        return data;
    }
}

export interface ILogDTO {
    logId: number;
    createdDate: moment.Moment;
    userId?: string | undefined;
    fromSpaceId?: number | undefined;
    spaceId?: number | undefined;
    fromFeatureId?: number | undefined;
    featureId?: number | undefined;
    fromPath?: string | undefined;
    path?: string | undefined;
    fromName?: string | undefined;
    name?: string | undefined;
    message?: string | undefined;
    action: LogActionType;
}

export enum LogActionType {
    None = 0,
    Create = 1,
    Update = 2,
    Delete = 3,
    Copy = 4,
    Move = 5,
    Permissions = 6,
}

/** A definition of a mutation. */
export class MutationDTO implements IMutationDTO {
    /** The items to mutate. */
    items?: number[] | undefined;
    /** The destination of the mutation. */
    destination!: number;

    constructor(data?: IMutationDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
            this.destination = _data["destination"];
        }
    }

    static fromJS(data: any): MutationDTO {
        data = typeof data === 'object' ? data : {};
        let result = new MutationDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        data["destination"] = this.destination;
        return data;
    }
}

/** A definition of a mutation. */
export interface IMutationDTO {
    /** The items to mutate. */
    items?: number[] | undefined;
    /** The destination of the mutation. */
    destination: number;
}

export class SpacePermissionDTO implements ISpacePermissionDTO {
    team?: string | undefined;
    inherit!: boolean;
    permission!: SpacePermissionType;

    constructor(data?: ISpacePermissionDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.team = _data["team"];
            this.inherit = _data["inherit"];
            this.permission = _data["permission"];
        }
    }

    static fromJS(data: any): SpacePermissionDTO {
        data = typeof data === 'object' ? data : {};
        let result = new SpacePermissionDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["team"] = this.team;
        data["inherit"] = this.inherit;
        data["permission"] = this.permission;
        return data;
    }
}

export interface ISpacePermissionDTO {
    team?: string | undefined;
    inherit: boolean;
    permission: SpacePermissionType;
}

export class LayerInfo implements ILayerInfo {
    attribution?: string | undefined;
    available?: Availability[][] | undefined;
    bounds?: number[] | undefined;
    description?: string | undefined;
    extensions?: string[] | undefined;
    format?: string | undefined;
    maxzoom!: number;
    minzoom!: number;
    name?: string | undefined;
    projection?: string | undefined;
    scheme?: string | undefined;
    tiles?: string[] | undefined;
    version?: string | undefined;

    constructor(data?: ILayerInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.attribution = _data["attribution"];
            if (Array.isArray(_data["available"])) {
                this.available = [] as any;
                for (let item of _data["available"])
                    this.available!.push(item);
            }
            if (Array.isArray(_data["bounds"])) {
                this.bounds = [] as any;
                for (let item of _data["bounds"])
                    this.bounds!.push(item);
            }
            this.description = _data["description"];
            if (Array.isArray(_data["extensions"])) {
                this.extensions = [] as any;
                for (let item of _data["extensions"])
                    this.extensions!.push(item);
            }
            this.format = _data["format"];
            this.maxzoom = _data["maxzoom"];
            this.minzoom = _data["minzoom"];
            this.name = _data["name"];
            this.projection = _data["projection"];
            this.scheme = _data["scheme"];
            if (Array.isArray(_data["tiles"])) {
                this.tiles = [] as any;
                for (let item of _data["tiles"])
                    this.tiles!.push(item);
            }
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): LayerInfo {
        data = typeof data === 'object' ? data : {};
        let result = new LayerInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["attribution"] = this.attribution;
        if (Array.isArray(this.available)) {
            data["available"] = [];
            for (let item of this.available)
                data["available"].push(item);
        }
        if (Array.isArray(this.bounds)) {
            data["bounds"] = [];
            for (let item of this.bounds)
                data["bounds"].push(item);
        }
        data["description"] = this.description;
        if (Array.isArray(this.extensions)) {
            data["extensions"] = [];
            for (let item of this.extensions)
                data["extensions"].push(item);
        }
        data["format"] = this.format;
        data["maxzoom"] = this.maxzoom;
        data["minzoom"] = this.minzoom;
        data["name"] = this.name;
        data["projection"] = this.projection;
        data["scheme"] = this.scheme;
        if (Array.isArray(this.tiles)) {
            data["tiles"] = [];
            for (let item of this.tiles)
                data["tiles"].push(item);
        }
        data["version"] = this.version;
        return data;
    }
}

export interface ILayerInfo {
    attribution?: string | undefined;
    available?: Availability[][] | undefined;
    bounds?: number[] | undefined;
    description?: string | undefined;
    extensions?: string[] | undefined;
    format?: string | undefined;
    maxzoom: number;
    minzoom: number;
    name?: string | undefined;
    projection?: string | undefined;
    scheme?: string | undefined;
    tiles?: string[] | undefined;
    version?: string | undefined;
}

export class Availability implements IAvailability {
    endX!: number;
    endY!: number;
    startX!: number;
    startY!: number;

    constructor(data?: IAvailability) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.endX = _data["endX"];
            this.endY = _data["endY"];
            this.startX = _data["startX"];
            this.startY = _data["startY"];
        }
    }

    static fromJS(data: any): Availability {
        data = typeof data === 'object' ? data : {};
        let result = new Availability();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endX"] = this.endX;
        data["endY"] = this.endY;
        data["startX"] = this.startX;
        data["startY"] = this.startY;
        return data;
    }
}

export interface IAvailability {
    endX: number;
    endY: number;
    startX: number;
    startY: number;
}

export class IconDTO implements IIconDTO {
    iconId!: number;
    iconBlob?: string | undefined;
    iconName?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    hotspotX?: number | undefined;
    hotspotY?: number | undefined;
    scaleFactor?: number | undefined;
    marginTop?: number | undefined;
    marginBottom?: number | undefined;
    marginLeft?: number | undefined;
    marginRight?: number | undefined;
    tenant?: string | undefined;

    constructor(data?: IIconDTO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iconId = _data["iconId"];
            this.iconBlob = _data["iconBlob"];
            this.iconName = _data["iconName"];
            this.width = _data["width"];
            this.height = _data["height"];
            this.hotspotX = _data["hotspotX"];
            this.hotspotY = _data["hotspotY"];
            this.scaleFactor = _data["scaleFactor"];
            this.marginTop = _data["marginTop"];
            this.marginBottom = _data["marginBottom"];
            this.marginLeft = _data["marginLeft"];
            this.marginRight = _data["marginRight"];
            this.tenant = _data["tenant"];
        }
    }

    static fromJS(data: any): IconDTO {
        data = typeof data === 'object' ? data : {};
        let result = new IconDTO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iconId"] = this.iconId;
        data["iconBlob"] = this.iconBlob;
        data["iconName"] = this.iconName;
        data["width"] = this.width;
        data["height"] = this.height;
        data["hotspotX"] = this.hotspotX;
        data["hotspotY"] = this.hotspotY;
        data["scaleFactor"] = this.scaleFactor;
        data["marginTop"] = this.marginTop;
        data["marginBottom"] = this.marginBottom;
        data["marginLeft"] = this.marginLeft;
        data["marginRight"] = this.marginRight;
        data["tenant"] = this.tenant;
        return data;
    }
}

export interface IIconDTO {
    iconId: number;
    iconBlob?: string | undefined;
    iconName?: string | undefined;
    width?: number | undefined;
    height?: number | undefined;
    hotspotX?: number | undefined;
    hotspotY?: number | undefined;
    scaleFactor?: number | undefined;
    marginTop?: number | undefined;
    marginBottom?: number | undefined;
    marginLeft?: number | undefined;
    marginRight?: number | undefined;
    tenant?: string | undefined;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

/**
 *  We are extending the AuthorizeClientBase to 
 *  add the application schema header to the request
 * */